import React from 'react';
import './EnIn.css';

function EnIn() {
  return (
    <div className="page-enin">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-726352421_1977"
          >
            <rect width="40" height="40" rx="20" fill="#E8E8E8" />
            <path
              d="M29.1681 28.6838C19.0481 33.5 12.7675 29.4704 8.74716 27.0229C8.49838 26.8686 8.07555 27.0589 8.44242 27.4803C9.78181 29.1044 14.1713 33.0188 19.9008 33.0188C25.6343 33.0188 29.0452 29.8903 29.4718 29.3446C29.8956 28.8035 29.5963 28.505 29.168 28.6838H29.1681ZM32.0102 27.1141C31.7385 26.7603 30.3577 26.6943 29.4888 26.801C28.6185 26.9047 27.3122 27.4366 27.4257 27.756C27.484 27.8756 27.603 27.8219 28.2008 27.7682C28.8003 27.7084 30.4798 27.4964 30.8297 27.9539C31.1813 28.4145 30.2941 30.6088 30.132 30.9627C29.9755 31.3166 30.1918 31.4078 30.4859 31.1721C30.7759 30.9365 31.301 30.3264 31.6534 29.4629C32.0033 28.5947 32.2168 27.3836 32.0102 27.1141Z"
              fill="#FF9900"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.3635 18.8562C22.3635 20.1199 22.3955 21.1738 21.7567 22.2961C21.2412 23.2086 20.4246 23.7697 19.5121 23.7697C18.2666 23.7697 17.5412 22.8207 17.5412 21.4202C17.5412 18.6554 20.0184 18.1537 22.3635 18.1537V18.8562ZM25.6346 26.7626C25.4201 26.9541 25.1099 26.9679 24.8682 26.8401C23.7915 25.9459 23.5998 25.5308 23.0068 24.6776C21.2275 26.4934 19.9683 27.0362 17.6599 27.0362C14.9317 27.0362 12.8057 25.3528 12.8057 21.9813C12.8057 19.349 14.2337 17.556 16.2638 16.6801C18.0248 15.9044 20.4839 15.7676 22.3635 15.5532V15.1335C22.3635 14.3624 22.4228 13.45 21.9712 12.784C21.5742 12.1863 20.8169 11.9399 20.1508 11.9399C18.9145 11.9399 17.8104 12.574 17.5412 13.888C17.4864 14.18 17.2721 14.4674 16.9801 14.4811L13.8321 14.1436C13.5676 14.0841 13.2756 13.8698 13.3486 13.4637C14.074 9.64975 17.5183 8.5 20.6024 8.5C22.1809 8.5 24.243 8.91976 25.4885 10.1151C27.0671 11.5886 26.9165 13.5549 26.9165 15.6946V20.7495C26.9165 22.2688 27.5461 22.9348 28.1391 23.7561C28.349 24.048 28.3946 24.3994 28.13 24.6183C27.4685 25.1703 26.2914 26.1968 25.6436 26.7717L25.6346 26.7626Z"
              fill="black"
            />
          </svg>
          <svg
            width="52"
            height="56"
            viewBox="0 0 52 56"
            fill="none"
            id="svg764373717_1237"
          >
            <path
              d="M4.1178 43.9966C6.70645 44.1861 9.19117 44.3576 11.6734 44.5383C12.1685 44.5721 12.5179 44.5965 13.1315 44.7412C13.5884 44.8438 14.5526 45.0824 14.3386 45.549C14.1216 45.9159 13.9208 46.1488 13.0542 46.1736C10.8158 46.2263 8.58772 45.9456 6.37559 45.6791C4.42238 45.4424 2.9366 45.2321 1.2209 44.9207C0.419624 44.7752 0.20983 44.3038 0.494828 43.6091C0.750833 42.9857 1.00256 42.3414 1.37105 41.7778C2.68853 39.7385 4.05394 37.7418 5.40585 35.7216C5.57222 35.4696 5.68687 35.2631 5.9277 34.9915C6.22271 34.6653 6.41922 34.4115 6.78617 34.6284C7.13714 34.8312 6.97041 35.3797 6.83171 35.6391C5.72009 37.8323 3.35158 42.3184 3.27991 42.5858C4.69575 42.1348 6.01556 41.7471 7.31578 41.2848C16.3552 38.0228 25.0854 34.1441 32.7865 28.24C38.8826 23.5665 44.3202 18.2519 48.9332 12.1036C49.208 11.7422 49.5172 11.4 49.8214 11.0762C50.2273 10.6314 50.5172 10.4718 50.7617 10.6659C51.1715 11.092 50.973 11.4639 50.8404 11.7743C50.5844 12.3977 50.1925 12.9748 49.8148 13.5359C44.6841 20.9889 38.103 26.9559 30.7091 32.0823C23.1207 37.3445 14.6704 40.6952 5.9054 43.3388C5.43779 43.4606 4.30986 43.8701 4.1178 43.9966Z"
              fill="black"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-738554790_445"
          >
            <path
              d="M0.461426 11.5386H11.5383M1.07681 4.76936V11.5386M10.923 4.76936V11.5386M3.53835 7.2309V9.07705M5.99989 7.2309V9.07705M8.46143 7.2309V9.07705M5.99989 2.92321H6.00604M0.461426 4.76936H11.5383V2.92321L5.99989 0.46167L0.461426 2.92321V4.76936Z"
              stroke="#2563EB"
              strokeWidth={1.22948}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="14"
            height="7"
            viewBox="-1 -1 14 7"
            fill="none"
            id="svg95803052_220"
          >
            <path
              opacity="0.12"
              d="M11.5383 2.92321L5.99989 0.46167L0.461426 2.92321V4.76936H11.5383V2.92321Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="59"
            height="61"
            viewBox="0 0 59 61"
            fill="none"
            id="svg147118731_1233"
          >
            <path
              d="M33.2756 3.78131C31.3111 5.47779 29.4329 7.11348 27.5499 8.74089C27.1759 9.06708 26.9116 9.29684 26.3754 9.62848C25.9797 9.87896 25.1293 10.392 24.9507 9.91078C24.8446 9.49791 24.8219 9.19126 25.4172 8.56089C26.9627 6.9409 28.7367 5.56386 30.4894 4.18811C32.0379 2.97434 33.2372 2.07243 34.6706 1.07947C35.34 0.615768 35.8217 0.800754 36.1114 1.49351C36.3712 2.11533 36.6488 2.74891 36.7867 3.408C37.2971 5.78157 37.7436 8.15898 38.2161 10.5434C38.2766 10.8392 38.3416 11.0663 38.3633 11.4286C38.3854 11.8679 38.4259 12.1864 38.013 12.2924C37.6215 12.3972 37.3516 11.8915 37.2662 11.61C36.5014 9.27309 35.0041 4.4262 34.8656 4.18639C34.1834 5.50645 33.5243 6.71389 32.9318 7.96012C28.8465 16.6586 25.416 25.5744 24.1454 35.1948C23.1394 42.81 23.0524 50.4129 24.138 58.0224C24.1993 58.4722 24.2226 58.9328 24.2365 59.3769C24.264 59.9784 24.1719 60.2962 23.8617 60.3319C23.2707 60.3204 23.1481 59.917 23.0223 59.6037C22.7625 58.9819 22.6316 58.2968 22.5019 57.6329C20.8598 48.7349 21.294 39.862 22.8973 31.0088C24.5423 21.9221 28.1482 13.5776 32.4767 5.5105C32.7212 5.09369 33.2292 4.00655 33.2756 3.78131Z"
              fill="black"
            />
          </svg>
          <svg
            width="40"
            height="52"
            viewBox="0 0 40 52"
            fill="none"
            id="svg-701020576_3786"
          >
            <path
              d="M8.6487 5.47214C10.0442 5.85274 11.4397 6.10647 12.8352 6.48706C14.2308 6.86766 15.6263 7.12139 17.0218 7.50198C17.4024 7.62885 17.5292 7.50198 17.6561 7.12139C18.1636 4.96468 18.671 2.93485 19.1785 0.778145C19.3054 0.39755 19.4322 0.270685 19.8128 0.39755C21.0815 0.778145 22.2232 1.03187 23.4919 1.2856C23.8725 1.41247 23.8725 1.53933 23.7456 1.79306C23.2382 3.8229 22.7307 5.97961 22.2232 8.00944C22.2232 8.13631 22.2232 8.26317 22.0964 8.5169C23.1113 8.77063 24.2531 9.02436 25.268 9.27809C25.3949 9.27809 25.5217 9.02436 25.6486 8.8975C26.0292 7.24825 26.4098 5.72587 26.9172 4.07663C27.0441 3.56917 27.171 3.06171 27.2978 2.55425C27.2978 2.30052 27.4247 2.17366 27.6784 2.30052C28.9471 2.68112 30.2157 2.93485 31.6112 3.31544C31.7381 3.31544 31.7381 3.44231 31.865 3.44231C31.4844 5.09155 31.1038 6.61393 30.7232 8.13631C30.5963 8.77063 30.4695 9.40496 30.2157 10.0393C30.0889 10.4199 30.2157 10.5467 30.5963 10.6736C31.9918 11.3079 33.3874 11.9423 34.7829 12.5766C36.0515 13.3378 37.1933 14.3527 38.0814 15.6213C39.2231 17.5243 39.35 19.5541 38.8425 21.584C38.4619 22.9795 37.9545 24.2481 36.9396 25.2631C36.1784 26.0243 35.1635 26.5317 34.1485 26.9123C34.0217 26.9123 33.8948 27.0392 33.6411 27.0392C34.1485 27.4198 34.656 27.6735 35.1635 28.0541C36.6858 29.1959 37.7008 30.5914 38.2082 32.3675C38.4619 33.763 38.3351 35.2854 37.9545 36.6809C37.447 38.457 36.8127 39.9794 35.6709 41.3749C34.2754 43.0242 32.4993 43.9122 30.4695 44.1659C27.8053 44.5465 25.268 44.2928 22.7307 43.9122C22.3501 43.7853 22.0964 43.9122 21.9695 44.2928C21.4621 46.3226 20.9546 48.4793 20.4471 50.5092C20.3203 51.0166 20.3203 51.1435 19.6859 50.8898C18.5442 50.636 17.2755 50.2555 16.1337 50.0017C15.7531 49.8749 15.7531 49.748 15.88 49.4943C16.3875 47.3376 16.8949 45.1809 17.5292 43.151C17.5292 42.8973 17.6561 42.7704 17.4024 42.6436C16.3875 42.3898 15.3725 42.1361 14.2308 41.8824C13.977 43.0242 13.5964 44.1659 13.3427 45.3077C13.089 46.4495 12.7084 47.5913 12.4546 48.7331C12.3278 48.9868 12.3278 49.1137 11.9472 48.9868C10.6785 48.6062 9.40989 48.3525 8.14124 48.0987C7.76065 47.9719 7.76065 47.845 7.88751 47.5913C8.39497 45.4346 8.90243 43.2779 9.53676 41.248C9.53676 41.1212 9.66362 40.9943 9.66362 40.7406C6.74573 39.9794 3.82784 39.2182 0.783081 38.457C1.03681 37.9496 1.16368 37.569 1.41741 37.0615C1.92486 35.9197 2.43233 34.7779 2.81292 33.763C2.93978 33.3824 3.06665 33.3824 3.44724 33.3824C4.3353 33.6362 5.35022 33.8899 6.23827 34.0167C7.25319 34.2705 8.01438 33.763 8.14124 32.875C9.79049 26.4049 11.4397 19.9347 12.9621 13.3378C13.2158 12.3228 12.5815 11.1811 11.4397 10.8005C10.2979 10.4199 9.15616 10.1661 8.14124 9.91242C7.88751 9.91242 7.76065 9.78555 7.88751 9.53182C8.26811 8.13631 8.6487 6.61393 9.0293 5.21842C8.52184 5.59901 8.52184 5.59901 8.6487 5.47214ZM15.1188 36.8078C15.2457 36.8078 15.3725 36.9346 15.3725 36.9346C17.4024 37.4421 19.5591 38.0764 21.7158 38.2033C23.2382 38.3302 24.6337 38.3302 26.0292 37.8227C28.4396 37.0615 29.4545 33.8899 28.059 31.86C27.4247 30.8451 26.4098 30.2108 25.3949 29.5765C23.1113 28.3078 20.4471 27.8004 17.9098 27.2929C17.5292 27.166 17.5292 27.2929 17.4024 27.6735C17.1486 28.9422 16.7681 30.0839 16.5143 31.3526C16.0069 33.1287 15.6263 34.9048 15.1188 36.8078ZM25.7755 23.8676C26.0292 23.8676 26.6635 23.7407 27.171 23.6138C29.5814 23.1064 30.8501 20.3153 29.5814 18.1586C28.9471 17.0169 27.8053 16.2557 26.6635 15.7482C24.8874 14.987 23.1113 14.6064 21.2083 14.099C20.8277 13.9721 20.7009 14.099 20.574 14.4796C19.9397 17.1437 19.3054 19.681 18.5442 22.3452C18.4173 22.5989 18.5442 22.7258 18.7979 22.8526C19.3054 22.9795 19.6859 23.1064 20.1934 23.2332C22.0964 23.487 23.7456 23.8676 25.7755 23.8676Z"
              fill="white"
            />
          </svg>
          <svg
            width="14"
            height="11"
            viewBox="-1 -1 14 11"
            fill="none"
            id="svg-212988539_408"
          >
            <path
              opacity="0.12"
              d="M1.69171 8.53839H10.3071C10.9868 8.53839 11.5379 7.99421 11.5379 7.32293V1.24561C11.5379 0.574333 10.9868 0.0301514 10.3071 0.0301514H1.69171C1.01197 0.0301514 0.460938 0.574333 0.460938 1.24561V3.06881V7.32293C0.460938 7.99421 1.01197 8.53839 1.69171 8.53839Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-1448888000_2617"
          >
            <path
              d="M1.3025 2.75332L1.11028 2.16941H1.11028L1.3025 2.75332ZM8.07174 0.524975L8.26395 1.10889L8.07174 0.524975ZM8.76863 6.66973C8.42912 6.66973 8.15389 6.94496 8.15389 7.28448C8.15389 7.62399 8.42912 7.89922 8.76863 7.89922V6.66973ZM8.77478 7.89922C9.1143 7.89922 9.38953 7.62399 9.38953 7.28448C9.38953 6.94496 9.1143 6.66973 8.77478 6.66973V7.89922ZM10.3071 11.5386V10.9239H1.69171V11.5386V12.1533H10.3071V11.5386ZM0.460938 10.3231H1.07568V6.06901H0.460938H-0.153804V10.3231H0.460938ZM0.460938 6.06901H1.07568V4.24582H0.460938H-0.153804V6.06901H0.460938ZM1.69171 11.5386V10.9239C1.34421 10.9239 1.07568 10.6477 1.07568 10.3231H0.460938H-0.153804C-0.153804 11.3412 0.679735 12.1533 1.69171 12.1533V11.5386ZM1.69171 3.03036V2.41561C0.679735 2.41561 -0.153804 3.22779 -0.153804 4.24582H0.460938H1.07568C1.07568 3.92128 1.34421 3.6451 1.69171 3.6451V3.03036ZM10.3071 11.5386V12.1533C11.3191 12.1533 12.1526 11.3412 12.1526 10.3231H11.5379H10.9231C10.9231 10.6477 10.6546 10.9239 10.3071 10.9239V11.5386ZM11.5379 4.24582H12.1526C12.1526 3.2278 11.3191 2.41561 10.3071 2.41561V3.03036V3.6451C10.6546 3.6451 10.9231 3.92128 10.9231 4.24582H11.5379ZM9.69171 1.67806H9.07697V2.78204H9.69171H10.3064V1.67806H9.69171ZM0.460938 6.06901H1.07568V3.90641H0.460938H-0.153804V6.06901H0.460938ZM1.3025 2.75332L1.49472 3.33724L8.26395 1.10889L8.07174 0.524975L7.87952 -0.058942L1.11028 2.16941L1.3025 2.75332ZM0.460938 3.90641H1.07568C1.07568 3.65281 1.24035 3.42098 1.49472 3.33724L1.3025 2.75332L1.11028 2.16941C0.359503 2.41655 -0.153804 3.11367 -0.153804 3.90641H0.460938ZM9.69171 1.67806H10.3064C10.3064 0.418947 9.06374 -0.448774 7.87952 -0.058942L8.07174 0.524975L8.26395 1.10889C8.67365 0.974025 9.07697 1.27794 9.07697 1.67806H9.69171ZM8.76863 7.28448V7.89922H8.77478V7.28448V6.66973H8.76863V7.28448ZM9.07632 7.28448H8.46158C8.46158 7.10555 8.60633 6.9736 8.76863 6.9736V7.58834V8.20308C9.2708 8.20308 9.69106 7.79904 9.69106 7.28448H9.07632ZM8.76863 7.58834V6.9736C8.93093 6.9736 9.07568 7.10555 9.07568 7.28448H8.46094H7.8462C7.8462 7.79904 8.26646 8.20308 8.76863 8.20308V7.58834ZM8.46094 7.28448H9.07568C9.07568 7.4634 8.93093 7.59535 8.76863 7.59535V6.98061V6.36587C8.26646 6.36587 7.8462 6.76991 7.8462 7.28448H8.46094ZM8.76863 6.98061V7.59535C8.60633 7.59535 8.46158 7.4634 8.46158 7.28448H9.07632H9.69106C9.69106 6.76991 9.2708 6.36587 8.76863 6.36587V6.98061ZM11.5379 10.3231H12.1526V4.24582H11.5379H10.9231V10.3231H11.5379ZM10.3071 3.03036V2.41561H1.69171V3.03036V3.6451H10.3071V3.03036Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="58"
            height="52"
            viewBox="0 0 58 52"
            fill="none"
            id="svg-417222547_3895"
          >
            <path
              d="M29.1864 1.07079C35.0648 1.07079 40.708 1.07079 46.5864 1.07079C47.0567 1.07079 47.2918 1.30894 47.2918 1.54709C50.5837 8.92978 53.8756 16.0743 57.4026 23.2189C57.6377 23.457 57.4026 23.6952 57.1675 23.9333C53.1702 27.9819 49.1729 32.0305 44.9405 36.079C39.7675 41.0802 34.3594 46.3195 29.1864 51.3207C28.7162 51.5588 28.7162 51.5588 28.481 51.3207C23.3081 46.3195 18.1351 41.3184 12.9621 36.079C8.96485 32.0305 4.73243 27.9819 0.735136 23.9333C0.500001 23.6952 0.5 23.457 0.5 23.2189C2.14594 19.4084 4.02702 15.8362 5.67296 12.0257C7.3189 8.45348 8.96485 5.11936 10.6108 1.54709C10.8459 1.07079 11.0811 0.832642 11.7865 0.832642C17.6648 1.07079 23.3081 0.832643 29.1864 1.07079ZM29.4216 7.50087C25.1891 7.50087 20.7216 7.50087 16.4892 7.50087C16.254 7.50087 16.254 7.50087 16.0189 7.50087C15.7838 7.50087 15.7838 7.50087 15.7838 7.73903C15.7838 9.88239 15.7838 12.0257 15.5486 14.4073C15.5486 14.6454 15.5486 14.6454 15.7838 14.6454C16.4892 14.6454 17.1946 14.6454 17.9 14.6454C20.2513 14.6454 22.6027 14.6454 24.954 14.6454C25.1891 14.6454 25.1891 14.6454 25.4243 14.6454C25.6594 14.6454 25.6594 14.8836 25.6594 15.1217C25.6594 16.0743 25.6594 17.2651 25.6594 18.2177C25.6594 18.4558 25.6594 18.4558 25.4243 18.694C23.7783 18.9321 22.1324 18.9321 20.4865 19.1703C18.3702 19.4084 16.254 19.8847 14.3729 20.5992C13.4324 20.8373 12.727 21.3136 12.0216 21.7899C11.3162 22.5044 11.3162 23.457 12.0216 23.9333C12.4919 24.4096 12.9621 24.6478 13.4324 24.8859C15.0784 25.6004 16.7243 25.8385 18.3702 26.3148C20.7216 26.7911 23.0729 27.0293 25.4243 27.2674C25.8946 27.2674 25.8946 27.2674 25.8946 27.7437C25.8946 32.0304 25.8946 36.5553 25.8946 40.842C25.8946 41.3184 25.8946 41.3183 26.3648 41.3183C28.481 41.3183 30.8324 41.3183 32.9486 41.3183C33.654 41.3183 33.654 41.3183 33.654 40.6039C33.654 37.0316 33.654 33.6975 33.654 30.1252C33.654 29.1726 33.654 28.22 33.654 27.2674C33.654 26.7911 33.8891 26.7911 34.1243 26.7911C36.4756 26.7911 38.5918 26.553 40.9432 26.0767C42.8243 25.8385 44.4702 25.3622 46.1161 24.6478C46.5864 24.4096 47.0567 23.9333 47.5269 23.6952C47.9972 23.2189 47.9972 22.7426 47.5269 22.2663C47.0567 22.0281 46.8215 21.5518 46.3513 21.3136C43.5297 19.6466 40.2378 18.9321 36.9459 18.694C36.0053 18.694 35.0648 18.694 34.1243 18.4558C33.8891 18.4558 33.8891 18.4558 33.8891 17.9795C33.8891 17.0269 33.8891 15.8362 33.8891 14.8836C33.8891 14.6454 33.8891 14.4073 34.3594 14.4073C35.0648 14.4073 35.7702 14.4073 36.4756 14.4073C38.827 14.4073 40.9432 14.4073 43.2945 14.4073C43.7648 14.4073 43.7648 14.1691 43.7648 13.931C43.7648 13.6928 43.7648 13.6928 43.7648 13.4547C43.7648 11.5494 43.7648 9.64423 43.7648 7.50087C43.7648 7.02457 43.7648 7.02457 43.2945 7.02457C38.1216 7.50088 33.654 7.50087 29.4216 7.50087Z"
              fill="white"
            />
            <path
              d="M28.245 25.6002C26.599 25.6002 25.1882 25.6002 23.5423 25.362C20.9558 25.1239 18.1342 24.8857 15.5477 23.9331C15.0774 23.6949 14.6072 23.4568 13.9018 23.2186C13.1964 22.7423 13.1964 22.266 13.9018 22.0279C14.8423 21.5516 15.7828 21.3134 16.7234 21.0753C18.6045 20.599 20.4855 20.3608 22.6017 20.1227C23.3072 20.1227 24.2477 19.8845 24.9531 19.8845C25.1882 19.8845 25.4234 19.8845 25.4234 20.3608C25.4234 21.7897 25.4234 22.9805 25.4234 24.4094C25.4234 24.8857 25.6585 24.8857 25.8936 24.8857C27.7747 24.8857 29.6558 24.8857 31.3017 24.8857C31.772 24.8857 32.2423 24.8857 32.7125 24.8857C33.1828 24.8857 33.1828 24.8857 33.1828 24.4094C33.1828 23.2186 33.1828 22.0279 33.1828 20.8371C33.1828 20.1227 33.1828 20.1227 33.8882 20.1227C36.945 20.3608 40.0017 20.599 43.0585 21.5516C43.5288 21.7897 44.2342 22.0279 44.7044 22.266C45.1747 22.5042 45.1747 22.9805 44.7044 23.2186C43.7639 23.9331 42.8233 24.1712 41.6477 24.4094C39.2963 24.8857 36.945 25.362 34.5936 25.362C32.7125 25.362 30.3612 25.6002 28.245 25.6002Z"
              fill="white"
            />
          </svg>
          <svg
            width="120"
            height="40"
            viewBox="0 0 120 40"
            fill="none"
            id="svg303028490_9230"
          >
            <rect
              x="0.5"
              y="0.5"
              width="119"
              height="39"
              rx="6.5"
              fill="#0C0D10"
            />
            <rect
              x="0.5"
              y="0.5"
              width="119"
              height="39"
              rx="6.5"
              stroke="#A6A6A6"
            />
            <path
              d="M81.5259 19.2013V21.4924H80.0899V22.9948H81.5259V28.0998C81.5259 29.8429 82.3145 30.5402 84.2984 30.5402C84.647 30.5402 84.9791 30.4987 85.2696 30.4489V28.9631C85.0206 28.988 84.8628 29.0046 84.5889 29.0046C83.7007 29.0046 83.3106 28.5895 83.3106 27.6432V22.9948H85.2696V21.4924H83.3106V19.2013H81.5259Z"
              fill="white"
            />
            <path
              d="M90.3234 30.6647C92.9631 30.6647 94.5817 28.8967 94.5817 25.9665C94.5817 23.0529 92.9548 21.2765 90.3234 21.2765C87.6838 21.2765 86.0568 23.0529 86.0568 25.9665C86.0568 28.8967 87.6755 30.6647 90.3234 30.6647ZM90.3234 29.0793C88.7712 29.0793 87.8996 27.9421 87.8996 25.9665C87.8996 24.0075 88.7712 22.862 90.3234 22.862C91.8674 22.862 92.7473 24.0075 92.7473 25.9665C92.7473 27.9338 91.8674 29.0793 90.3234 29.0793Z"
              fill="white"
            />
            <path
              d="M95.9666 30.4904H97.7513V25.153C97.7513 23.883 98.7059 23.028 100.059 23.028C100.374 23.028 100.906 23.0861 101.055 23.1359V21.3762C100.864 21.3263 100.524 21.3014 100.258 21.3014C99.0794 21.3014 98.075 21.9489 97.8177 22.8371H97.6849V21.4509H95.9666V30.4904Z"
              fill="white"
            />
            <path
              d="M105.486 22.7956C106.806 22.7956 107.669 23.717 107.711 25.1364H103.145C103.245 23.7253 104.166 22.7956 105.486 22.7956ZM107.703 28.05C107.371 28.7555 106.632 29.1457 105.553 29.1457C104.125 29.1457 103.204 28.1413 103.145 26.5558V26.4562H109.529V25.8337C109.529 22.9948 108.01 21.2765 105.495 21.2765C102.946 21.2765 101.328 23.111 101.328 25.9997C101.328 28.8884 102.913 30.6647 105.503 30.6647C107.57 30.6647 109.014 29.6686 109.421 28.05H107.703Z"
              fill="white"
            />
            <path
              d="M69.8223 27.1522C69.96 29.372 71.8098 30.7915 74.5629 30.7915C77.5053 30.7915 79.3464 29.3031 79.3464 26.9286C79.3464 25.0616 78.2968 24.0292 75.7502 23.4355L74.3822 23.1C72.7647 22.7214 72.1109 22.2138 72.1109 21.3277C72.1109 20.2092 73.1261 19.4779 74.6489 19.4779C76.0943 19.4779 77.0923 20.192 77.273 21.3363H79.1486C79.0367 19.2456 77.1956 17.7744 74.6747 17.7744C71.9646 17.7744 70.1579 19.2456 70.1579 21.4567C70.1579 23.2807 71.1817 24.3647 73.4272 24.8895L75.0275 25.2767C76.6707 25.6638 77.3934 26.2317 77.3934 27.1781C77.3934 28.2793 76.2578 29.0794 74.7091 29.0794C73.0487 29.0794 71.8958 28.3309 71.7323 27.1522H69.8223Z"
              fill="white"
            />
            <path
              d="M51.335 21.3014C50.1065 21.3014 49.044 21.9157 48.4961 22.945H48.3633V21.4509H46.6451V33.4953H48.4297V29.1208H48.5708C49.044 30.0754 50.065 30.6398 51.3516 30.6398C53.6343 30.6398 55.087 28.8386 55.087 25.9665C55.087 23.0944 53.6343 21.3014 51.335 21.3014ZM50.8287 29.0378C49.3345 29.0378 48.3965 27.8591 48.3965 25.9748C48.3965 24.0822 49.3345 22.9035 50.837 22.9035C52.3477 22.9035 53.2525 24.0573 53.2525 25.9665C53.2525 27.884 52.3477 29.0378 50.8287 29.0378Z"
              fill="white"
            />
            <path
              d="M61.3318 21.3014C60.1033 21.3014 59.0408 21.9157 58.4929 22.945H58.3601V21.4509H56.6419V33.4953H58.4265V29.1208H58.5676C59.0408 30.0754 60.0618 30.6398 61.3484 30.6398C63.6311 30.6398 65.0838 28.8386 65.0838 25.9665C65.0838 23.0944 63.6311 21.3014 61.3318 21.3014ZM60.8255 29.0378C59.3313 29.0378 58.3933 27.8591 58.3933 25.9748C58.3933 24.0822 59.3313 22.9035 60.8338 22.9035C62.3445 22.9035 63.2493 24.0573 63.2493 25.9665C63.2493 27.884 62.3445 29.0378 60.8255 29.0378Z"
              fill="white"
            />
            <path
              d="M43.4431 30.4904H45.4907L41.0083 18.0755H38.9348L34.4524 30.4904H36.4312L37.5755 27.1953H42.3074L43.4431 30.4904ZM39.8726 20.3297H40.0189L41.817 25.5778H38.0659L39.8726 20.3297Z"
              fill="white"
            />
            <path
              d="M35.6511 8.71069V14.6997H37.8135C39.5981 14.6997 40.6316 13.5999 40.6316 11.6865C40.6316 9.80225 39.5898 8.71069 37.8135 8.71069H35.6511ZM36.5808 9.55737H37.7097C38.9507 9.55737 39.6853 10.3459 39.6853 11.699C39.6853 13.0728 38.9631 13.853 37.7097 13.853H36.5808V9.55737Z"
              fill="white"
            />
            <path
              d="M43.7967 14.7869C45.1165 14.7869 45.9258 13.9028 45.9258 12.4377C45.9258 10.981 45.1124 10.0928 43.7967 10.0928C42.4769 10.0928 41.6634 10.981 41.6634 12.4377C41.6634 13.9028 42.4727 14.7869 43.7967 14.7869ZM43.7967 13.9941C43.0206 13.9941 42.5848 13.4255 42.5848 12.4377C42.5848 11.4583 43.0206 10.8855 43.7967 10.8855C44.5687 10.8855 45.0086 11.4583 45.0086 12.4377C45.0086 13.4214 44.5687 13.9941 43.7967 13.9941Z"
              fill="white"
            />
            <path
              d="M52.818 10.1799H51.9256L51.1205 13.6289H51.0499L50.1202 10.1799H49.2652L48.3355 13.6289H48.2691L47.4598 10.1799H46.555L47.8001 14.6997H48.7174L49.6471 11.3711H49.7176L50.6515 14.6997H51.577L52.818 10.1799Z"
              fill="white"
            />
            <path
              d="M53.8456 14.6997H54.7379V12.0559C54.7379 11.3503 55.1571 10.9104 55.817 10.9104C56.477 10.9104 56.7924 11.2715 56.7924 11.9978V14.6997H57.6847V11.7737C57.6847 10.6987 57.1286 10.0928 56.12 10.0928C55.4394 10.0928 54.9911 10.3958 54.7711 10.8979H54.7047V10.1799H53.8456V14.6997Z"
              fill="white"
            />
            <path
              d="M59.09 14.6997H59.9824V8.41602H59.09V14.6997Z"
              fill="white"
            />
            <path
              d="M63.3384 14.7869C64.6582 14.7869 65.4675 13.9028 65.4675 12.4377C65.4675 10.981 64.6541 10.0928 63.3384 10.0928C62.0186 10.0928 61.2051 10.981 61.2051 12.4377C61.2051 13.9028 62.0144 14.7869 63.3384 14.7869ZM63.3384 13.9941C62.5623 13.9941 62.1265 13.4255 62.1265 12.4377C62.1265 11.4583 62.5623 10.8855 63.3384 10.8855C64.1104 10.8855 64.5503 11.4583 64.5503 12.4377C64.5503 13.4214 64.1104 13.9941 63.3384 13.9941Z"
              fill="white"
            />
            <path
              d="M68.1263 14.0232C67.6407 14.0232 67.2879 13.7866 67.2879 13.3799C67.2879 12.9814 67.5701 12.7698 68.1927 12.7283L69.2967 12.6577V13.0354C69.2967 13.5957 68.7986 14.0232 68.1263 14.0232ZM67.898 14.7744C68.4915 14.7744 68.9854 14.5171 69.2552 14.0647H69.3257V14.6997H70.1849V11.6118C70.1849 10.6572 69.5457 10.0928 68.4126 10.0928C67.3875 10.0928 66.657 10.5908 66.5657 11.3669H67.429C67.5286 11.0474 67.8731 10.8647 68.3711 10.8647C68.9812 10.8647 69.2967 11.1345 69.2967 11.6118V12.002L68.0723 12.0725C66.9974 12.1389 66.3914 12.6079 66.3914 13.4214C66.3914 14.2473 67.0264 14.7744 67.898 14.7744Z"
              fill="white"
            />
            <path
              d="M73.213 14.7744C73.8355 14.7744 74.3626 14.4797 74.6324 13.9858H74.703V14.6997H75.558V8.41602H74.6656V10.8979H74.5992C74.3543 10.3999 73.8314 10.1052 73.213 10.1052C72.0716 10.1052 71.337 11.01 71.337 12.4377C71.337 13.8696 72.0633 14.7744 73.213 14.7744ZM73.4662 10.9062C74.2132 10.9062 74.6822 11.4998 74.6822 12.4419C74.6822 13.3882 74.2174 13.9734 73.4662 13.9734C72.7108 13.9734 72.2584 13.3965 72.2584 12.4377C72.2584 11.4873 72.7149 10.9062 73.4662 10.9062Z"
              fill="white"
            />
            <path
              d="M81.3444 14.7869C82.6643 14.7869 83.4736 13.9028 83.4736 12.4377C83.4736 10.981 82.6601 10.0928 81.3444 10.0928C80.0246 10.0928 79.2111 10.981 79.2111 12.4377C79.2111 13.9028 80.0205 14.7869 81.3444 14.7869ZM81.3444 13.9941C80.5683 13.9941 80.1325 13.4255 80.1325 12.4377C80.1325 11.4583 80.5683 10.8855 81.3444 10.8855C82.1164 10.8855 82.5563 11.4583 82.5563 12.4377C82.5563 13.4214 82.1164 13.9941 81.3444 13.9941Z"
              fill="white"
            />
            <path
              d="M84.6548 14.6997H85.5471V12.0559C85.5471 11.3503 85.9663 10.9104 86.6262 10.9104C87.2861 10.9104 87.6016 11.2715 87.6016 11.9978V14.6997H88.4939V11.7737C88.4939 10.6987 87.9377 10.0928 86.9292 10.0928C86.2485 10.0928 85.8003 10.3958 85.5803 10.8979H85.5139V10.1799H84.6548V14.6997Z"
              fill="white"
            />
            <path
              d="M92.6036 9.05518V10.2007H91.8856V10.9519H92.6036V13.5044C92.6036 14.376 92.9979 14.7246 93.9898 14.7246C94.1642 14.7246 94.3302 14.7039 94.4754 14.679V13.936C94.3509 13.9485 94.2721 13.9568 94.1351 13.9568C93.691 13.9568 93.4959 13.7493 93.4959 13.2761V10.9519H94.4754V10.2007H93.4959V9.05518H92.6036Z"
              fill="white"
            />
            <path
              d="M95.6732 14.6997H96.5656V12.0601C96.5656 11.3752 96.9723 10.9146 97.7028 10.9146C98.3336 10.9146 98.6698 11.2798 98.6698 12.002V14.6997H99.5622V11.782C99.5622 10.707 98.9687 10.0969 98.0058 10.0969C97.3251 10.0969 96.8478 10.3999 96.6278 10.9062H96.5573V8.41602H95.6732V14.6997Z"
              fill="white"
            />
            <path
              d="M102.781 10.8523C103.441 10.8523 103.873 11.313 103.894 12.0227H101.611C101.661 11.3171 102.121 10.8523 102.781 10.8523ZM103.889 13.4795C103.723 13.8323 103.354 14.0273 102.814 14.0273C102.101 14.0273 101.64 13.5251 101.611 12.7324V12.6826H104.802V12.3713C104.802 10.9519 104.043 10.0928 102.785 10.0928C101.511 10.0928 100.702 11.01 100.702 12.4543C100.702 13.8987 101.495 14.7869 102.789 14.7869C103.823 14.7869 104.545 14.2888 104.748 13.4795H103.889Z"
              fill="white"
            />
            <path
              d="M24.769 20.3011C24.7907 18.6201 25.6934 17.0295 27.1256 16.149C26.2221 14.8587 24.7088 14.0406 23.1344 13.9913C21.4552 13.8151 19.8272 14.9962 18.9715 14.9962C18.0992 14.9962 16.7817 14.0088 15.363 14.038C13.5137 14.0978 11.7898 15.1491 10.8901 16.7659C8.95607 20.1143 10.3987 25.0354 12.2513 27.742C13.1782 29.0673 14.2615 30.5478 15.6789 30.4953C17.066 30.4377 17.584 29.6108 19.2583 29.6108C20.9171 29.6108 21.4031 30.4953 22.8493 30.4619C24.3377 30.4377 25.2754 29.1306 26.1698 27.7927C26.8358 26.8484 27.3483 25.8047 27.6882 24.7002C25.9391 23.9604 24.771 22.2002 24.769 20.3011Z"
              fill="white"
            />
            <path
              d="M22.0373 12.2113C22.8489 11.2371 23.2487 9.98494 23.1518 8.7207C21.912 8.85092 20.7668 9.44348 19.9443 10.3803C19.14 11.2956 18.7214 12.5258 18.8006 13.7417C20.0408 13.7545 21.2601 13.178 22.0373 12.2113Z"
              fill="white"
            />
          </svg>
          <svg
            width="340"
            height="215"
            viewBox="0 0 340 215"
            fill="none"
            id="svg-262421025_24617"
          >
            <rect
              width="340"
              height="215"
              rx="12"
              fill="url(#svg-262421025_24617_paint0_linear_1846_3275)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M101.857 80.3707C107.714 86.2287 107.714 95.7267 101.857 101.584C101.788 101.653 101.705 101.709 101.614 101.746C101.523 101.784 101.425 101.804 101.327 101.804C101.228 101.804 101.131 101.784 101.04 101.746C100.949 101.709 100.866 101.653 100.796 101.584L100.266 101.054C100.126 100.913 100.047 100.722 100.047 100.524C100.047 100.325 100.126 100.134 100.266 99.9937C105.245 95.0137 105.245 86.9407 100.266 81.9617C100.126 81.8211 100.047 81.6304 100.047 81.4317C100.047 81.2329 100.126 81.0423 100.266 80.9017L100.796 80.3717C100.937 80.2312 101.127 80.1523 101.326 80.1523C101.525 80.1523 101.716 80.2312 101.856 80.3717L101.857 80.3707ZM98.6752 83.5527C102.775 87.6527 102.775 94.3017 98.6752 98.4027C98.6056 98.4724 98.5229 98.5277 98.4319 98.5654C98.3408 98.6031 98.2433 98.6225 98.1447 98.6225C98.0462 98.6225 97.9487 98.6031 97.8576 98.5654C97.7666 98.5277 97.6839 98.4724 97.6142 98.4027L97.0842 97.8727C97.0144 97.803 96.959 97.7203 96.9212 97.6291C96.8834 97.538 96.8639 97.4403 96.8639 97.3417C96.8639 97.243 96.8834 97.1454 96.9212 97.0542C96.959 96.9631 97.0144 96.8804 97.0842 96.8107C98.6313 95.2635 99.5005 93.1652 99.5005 90.9772C99.5005 88.7892 98.6313 86.6908 97.0842 85.1437C96.9438 85.0031 96.8649 84.8124 96.8649 84.6137C96.8649 84.4149 96.9438 84.2243 97.0842 84.0837L97.6143 83.5537C97.7549 83.4132 97.9455 83.3343 98.1442 83.3343C98.343 83.3343 98.5336 83.4132 98.6742 83.5537L98.6752 83.5527ZM95.4932 86.7567C96.0505 87.3138 96.4926 87.9753 96.7941 88.7033C97.0957 89.4314 97.251 90.2117 97.251 90.9997C97.251 91.7877 97.0957 92.568 96.7941 93.296C96.4926 94.024 96.0505 94.6855 95.4932 95.2427C95.4236 95.3124 95.3409 95.3677 95.2499 95.4054C95.1588 95.4431 95.0613 95.4625 94.9627 95.4625C94.8642 95.4625 94.7667 95.4431 94.6756 95.4054C94.5846 95.3677 94.5019 95.3124 94.4322 95.2427L93.9022 94.7127C93.8326 94.643 93.7773 94.5603 93.7395 94.4693C93.7018 94.3783 93.6824 94.2807 93.6824 94.1822C93.6824 94.0837 93.7018 93.9861 93.7395 93.8951C93.7773 93.804 93.8326 93.7213 93.9022 93.6517C94.2506 93.3035 94.5269 92.89 94.7154 92.435C94.9039 91.9799 95.0009 91.4922 95.0009 90.9997C95.0009 90.5071 94.9039 90.0194 94.7154 89.5644C94.5269 89.1094 94.2506 88.6959 93.9022 88.3477C93.7618 88.2071 93.6829 88.0164 93.6829 87.8177C93.6829 87.6189 93.7618 87.4283 93.9022 87.2877L94.4322 86.7577C94.5729 86.6172 94.7635 86.5383 94.9622 86.5383C95.161 86.5383 95.3516 86.6172 95.4922 86.7577L95.4932 86.7567Z"
              fill="white"
            />
            <path
              d="M296 24C307.046 24 316 32.9543 316 44C316 55.0457 307.046 64 296 64C284.954 64 276 55.0457 276 44C276 32.9543 284.954 24 296 24ZM291.164 28.1758C291.04 28.1065 290.961 28.1332 290.821 28.1729C286.535 29.3946 282.92 32.2883 280.789 36.2021C278.631 40.0837 278.093 44.6605 279.293 48.9365C280.514 53.2919 283.442 56.9701 287.414 59.1357C289.485 60.2699 292.323 61.0553 294.708 60.9414C296.705 60.8804 298.487 60.2386 299.876 58.7646C301.068 57.5001 301.688 55.729 301.594 53.9902C301.396 50.3356 298.902 48.0396 296.441 45.6973C293.853 43.2332 290.716 40.9714 289.089 37.7412C288.826 37.2195 288.623 36.654 288.479 36.0928C288.423 35.8708 288.308 35.1693 288.245 35.0322L288.197 35.0361C288.054 35.2366 287.924 35.6733 287.836 35.9111C287.301 37.3622 287.122 38.8885 287.343 40.417C287.779 43.4338 290.104 45.5714 292.245 47.5205C293.13 48.3256 294.063 49.1092 294.94 49.9248C296.502 51.3861 298.328 53.1279 298.131 55.458C298.083 56.097 297.863 56.7111 297.494 57.2354C296.63 58.4533 295.369 58.6525 293.992 58.5938C291.785 58.4996 289.762 57.6664 288 56.3633C287.013 55.6312 286.123 54.7777 285.35 53.8232C282.82 50.5446 281.765 46.7934 282.297 42.666C282.806 38.6878 284.858 35.0683 288.011 32.5889C288.315 32.3509 288.635 32.1334 288.968 31.9375C289.371 30.7534 289.791 29.8516 290.62 28.8779C290.73 28.7494 291.179 28.2896 291.164 28.1758ZM297.16 26.9443C295.164 27.0054 293.382 27.6474 291.993 29.1211C290.802 30.3857 290.18 32.1568 290.274 33.8955C290.472 37.55 292.967 39.8462 295.427 42.1885C298.015 44.6525 301.153 46.9143 302.78 50.1445C303.043 50.6662 303.245 51.2318 303.389 51.793C303.446 52.015 303.561 52.7168 303.624 52.8535L303.671 52.8496C303.814 52.6492 303.945 52.2125 304.032 51.9746C304.567 50.5235 304.747 48.9973 304.525 47.4688C304.089 44.452 301.765 42.3143 299.624 40.3652C298.739 39.56 297.805 38.7766 296.928 37.9609C295.366 36.4998 293.541 34.7586 293.737 32.4287C293.786 31.7894 294.006 31.1748 294.375 30.6504C295.239 29.4324 296.5 29.2332 297.877 29.292C300.084 29.3862 302.108 30.2193 303.869 31.5225C304.856 32.2546 305.746 33.108 306.52 34.0625C309.049 37.3411 310.104 41.0923 309.572 45.2197C309.063 49.1979 307.011 52.8175 303.857 55.2969C303.553 55.5349 303.233 55.7524 302.9 55.9482C302.497 57.1323 302.079 58.0341 301.249 59.0078C301.14 59.136 300.689 59.596 300.704 59.71C300.829 59.7796 300.907 59.7527 301.048 59.7129C305.334 58.4911 308.949 55.5976 311.08 51.6836C313.239 47.802 313.775 43.2253 312.575 38.9492C311.355 34.5939 308.427 30.9156 304.455 28.75C302.384 27.6157 299.545 26.8304 297.16 26.9443Z"
              fill="#FAFAFA"
            />
            <path
              d="M38 80.3895C38 77.4129 40.2649 75 43.0588 75H75.9412C78.7351 75 81 77.4129 81 80.3895V101.611C81 104.587 78.7351 107 75.9412 107H43.0588C40.2649 107 38 104.587 38 101.611V80.3895Z"
              fill="url(#svg-262421025_24617_paint1_linear_1846_3275)"
            />
            <path
              d="M38 80.3895C38 77.4129 40.2649 75 43.0588 75H75.9412C78.7351 75 81 77.4129 81 80.3895V101.611C81 104.587 78.7351 107 75.9412 107H43.0588C40.2649 107 38 104.587 38 101.611V80.3895Z"
              fill="url(#svg-262421025_24617_paint2_linear_1846_3275)"
            />
            <path
              d="M43.0586 75.25H75.9414C78.5825 75.2501 80.75 77.5361 80.75 80.3896V101.61C80.75 104.464 78.5825 106.75 75.9414 106.75H43.0586C40.4175 106.75 38.25 104.464 38.25 101.61V80.3896C38.25 77.5361 40.4175 75.2501 43.0586 75.25ZM43.0586 75.4238C40.4613 75.424 38.3828 77.6623 38.3828 80.3896V101.61C38.3828 104.338 40.4613 106.576 43.0586 106.576H75.9414C78.5387 106.576 80.6172 104.338 80.6172 101.61V80.3896C80.6172 77.6623 78.5387 75.424 75.9414 75.4238H43.0586Z"
              stroke="#54585B"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="78.425"
              width="15.2525"
              height="6.75713"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="87.4961"
              width="15.2525"
              height="6.75712"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="96.5664"
              width="15.2525"
              height="6.75714"
              rx="3.37857"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="78.425"
              width="15.2525"
              height="6.75713"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="87.4961"
              width="15.2525"
              height="6.75712"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="96.5664"
              width="15.2525"
              height="6.75714"
              rx="3.37857"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <path
              d="M40.94 145H42.94V159H40.64V147.46L37.82 148.26L37.26 146.3L40.94 145ZM45.0614 159V157.2L49.9414 152.22C51.1281 151.033 51.7214 150.007 51.7214 149.14C51.7214 148.46 51.5147 147.933 51.1014 147.56C50.7014 147.173 50.1881 146.98 49.5614 146.98C48.3881 146.98 47.5214 147.56 46.9614 148.72L45.0214 147.58C45.4614 146.647 46.0814 145.94 46.8814 145.46C47.6814 144.98 48.5681 144.74 49.5414 144.74C50.7681 144.74 51.8214 145.127 52.7014 145.9C53.5814 146.673 54.0214 147.727 54.0214 149.06C54.0214 150.487 53.2281 152.007 51.6414 153.62L48.4814 156.78H54.2814V159H45.0614ZM61.512 150.72C62.5254 150.96 63.3454 151.433 63.972 152.14C64.612 152.833 64.932 153.707 64.932 154.76C64.932 156.16 64.4587 157.26 63.512 158.06C62.5654 158.86 61.4054 159.26 60.032 159.26C58.9654 159.26 58.0054 159.013 57.152 158.52C56.312 158.027 55.7054 157.307 55.332 156.36L57.292 155.22C57.7054 156.42 58.6187 157.02 60.032 157.02C60.832 157.02 61.4654 156.82 61.932 156.42C62.3987 156.007 62.632 155.453 62.632 154.76C62.632 154.067 62.3987 153.52 61.932 153.12C61.4654 152.72 60.832 152.52 60.032 152.52H59.512L58.592 151.14L61.612 147.16H55.752V145H64.352V146.96L61.512 150.72ZM77.2834 154.34V156.48H75.6834V159H73.3634V156.48H66.4834V154.34L71.3034 145H73.8034L68.9834 154.34H73.3634V150.7H75.6834V154.34H77.2834Z"
              fill="white"
            />
            <path
              d="M92.68 150.72C93.6933 150.96 94.5133 151.433 95.14 152.14C95.78 152.833 96.1 153.707 96.1 154.76C96.1 156.16 95.6267 157.26 94.68 158.06C93.7333 158.86 92.5733 159.26 91.2 159.26C90.1333 159.26 89.1733 159.013 88.32 158.52C87.48 158.027 86.8733 157.307 86.5 156.36L88.46 155.22C88.8733 156.42 89.7867 157.02 91.2 157.02C92 157.02 92.6333 156.82 93.1 156.42C93.5667 156.007 93.8 155.453 93.8 154.76C93.8 154.067 93.5667 153.52 93.1 153.12C92.6333 152.72 92 152.52 91.2 152.52H90.68L89.76 151.14L92.78 147.16H86.92V145H95.52V146.96L92.68 150.72ZM108.451 154.34V156.48H106.851V159H104.531V156.48H97.6514V154.34L102.471 145H104.971L100.151 154.34H104.531V150.7H106.851V154.34H108.451ZM109.413 159V157.2L114.293 152.22C115.48 151.033 116.073 150.007 116.073 149.14C116.073 148.46 115.866 147.933 115.453 147.56C115.053 147.173 114.54 146.98 113.913 146.98C112.74 146.98 111.873 147.56 111.313 148.72L109.373 147.58C109.813 146.647 110.433 145.94 111.233 145.46C112.033 144.98 112.92 144.74 113.893 144.74C115.12 144.74 116.173 145.127 117.053 145.9C117.933 146.673 118.373 147.727 118.373 149.06C118.373 150.487 117.58 152.007 115.993 153.62L112.833 156.78H118.633V159H109.413ZM123.124 145H125.124V159H122.824V147.46L120.004 148.26L119.444 146.3L123.124 145Z"
              fill="white"
            />
            <path
              d="M138.94 145H140.94V159H138.64V147.46L135.82 148.26L135.26 146.3L138.94 145ZM152.841 149.52C152.841 150.587 152.561 151.527 152.001 152.34L147.581 159H144.941L148.141 154.3H147.901C146.448 154.3 145.255 153.86 144.321 152.98C143.401 152.087 142.941 150.933 142.941 149.52C142.941 148.107 143.401 146.96 144.321 146.08C145.255 145.187 146.448 144.74 147.901 144.74C149.355 144.74 150.541 145.187 151.461 146.08C152.381 146.96 152.841 148.107 152.841 149.52ZM145.241 149.52C145.241 150.293 145.488 150.92 145.981 151.4C146.488 151.88 147.128 152.12 147.901 152.12C148.675 152.12 149.308 151.887 149.801 151.42C150.295 150.94 150.541 150.307 150.541 149.52C150.541 148.733 150.295 148.107 149.801 147.64C149.308 147.16 148.675 146.92 147.901 146.92C147.128 146.92 146.488 147.16 145.981 147.64C145.488 148.107 145.241 148.733 145.241 149.52ZM163.819 154.34V156.48H162.219V159H159.899V156.48H153.019V154.34L157.839 145H160.339L155.519 154.34H159.899V150.7H162.219V154.34H163.819ZM174.17 149.52C174.17 150.587 173.89 151.527 173.33 152.34L168.91 159H166.27L169.47 154.3H169.23C167.776 154.3 166.583 153.86 165.65 152.98C164.73 152.087 164.27 150.933 164.27 149.52C164.27 148.107 164.73 146.96 165.65 146.08C166.583 145.187 167.776 144.74 169.23 144.74C170.683 144.74 171.87 145.187 172.79 146.08C173.71 146.96 174.17 148.107 174.17 149.52ZM166.57 149.52C166.57 150.293 166.816 150.92 167.31 151.4C167.816 151.88 168.456 152.12 169.23 152.12C170.003 152.12 170.636 151.887 171.13 151.42C171.623 150.94 171.87 150.307 171.87 149.52C171.87 148.733 171.623 148.107 171.13 147.64C170.636 147.16 170.003 146.92 169.23 146.92C168.456 146.92 167.816 147.16 167.31 147.64C166.816 148.107 166.57 148.733 166.57 149.52Z"
              fill="white"
            />
            <path
              d="M188.5 150.28C189.833 150.28 190.96 150.68 191.88 151.48C192.8 152.267 193.26 153.36 193.26 154.76C193.26 156.16 192.787 157.26 191.84 158.06C190.893 158.86 189.733 159.26 188.36 159.26C187.253 159.26 186.273 159.007 185.42 158.5C184.567 157.98 183.96 157.233 183.6 156.26L185.58 155.12C185.953 156.387 186.88 157.02 188.36 157.02C189.147 157.02 189.773 156.82 190.24 156.42C190.72 156.007 190.96 155.453 190.96 154.76C190.96 154.067 190.727 153.52 190.26 153.12C189.793 152.72 189.173 152.52 188.4 152.52H184.32L184.86 145H192.66V147.16H186.98L186.74 150.28H188.5ZM199.358 149.7C200.812 149.7 201.998 150.147 202.918 151.04C203.838 151.92 204.298 153.067 204.298 154.48C204.298 155.893 203.838 157.047 202.918 157.94C201.998 158.82 200.812 159.26 199.358 159.26C197.892 159.26 196.698 158.82 195.778 157.94C194.858 157.047 194.398 155.893 194.398 154.48C194.398 153.413 194.678 152.473 195.238 151.66L199.678 145H202.298L199.098 149.7H199.358ZM199.358 157.08C200.132 157.08 200.765 156.847 201.258 156.38C201.752 155.9 201.998 155.267 201.998 154.48C201.998 153.693 201.752 153.067 201.258 152.6C200.765 152.12 200.132 151.88 199.358 151.88C198.572 151.88 197.932 152.12 197.438 152.6C196.945 153.067 196.698 153.693 196.698 154.48C196.698 155.267 196.945 155.9 197.438 156.38C197.932 156.847 198.572 157.08 199.358 157.08ZM203.886 145H212.786V147L207.866 159H205.446L210.286 147.2H203.886V145ZM221.069 151.72C222.443 152.48 223.129 153.613 223.129 155.12C223.129 156.4 222.683 157.413 221.789 158.16C220.896 158.893 219.709 159.26 218.229 159.26C216.749 159.26 215.556 158.893 214.649 158.16C213.756 157.413 213.309 156.4 213.309 155.12C213.309 154.4 213.489 153.747 213.849 153.16C214.209 152.56 214.716 152.08 215.369 151.72C214.316 151.027 213.789 150.04 213.789 148.76C213.789 147.48 214.216 146.493 215.069 145.8C215.923 145.093 216.976 144.74 218.229 144.74C219.469 144.74 220.516 145.093 221.369 145.8C222.236 146.493 222.669 147.48 222.669 148.76C222.669 150.04 222.136 151.027 221.069 151.72ZM218.229 146.92C217.603 146.92 217.089 147.087 216.689 147.42C216.289 147.753 216.089 148.233 216.089 148.86C216.089 149.46 216.289 149.933 216.689 150.28C217.103 150.627 217.616 150.8 218.229 150.8C218.829 150.8 219.336 150.627 219.749 150.28C220.163 149.933 220.369 149.46 220.369 148.86C220.369 148.233 220.163 147.753 219.749 147.42C219.349 147.087 218.843 146.92 218.229 146.92ZM218.229 157.08C219.003 157.08 219.629 156.893 220.109 156.52C220.589 156.133 220.829 155.593 220.829 154.9C220.829 154.207 220.589 153.673 220.109 153.3C219.629 152.913 219.003 152.72 218.229 152.72C217.443 152.72 216.809 152.913 216.329 153.3C215.849 153.673 215.609 154.207 215.609 154.9C215.609 155.593 215.849 156.133 216.329 156.52C216.809 156.893 217.443 157.08 218.229 157.08Z"
              fill="white"
            />
            <path
              d="M41.848 194.208C40.7707 194.208 39.8533 193.963 39.096 193.472C38.3493 192.981 37.8267 192.309 37.528 191.456L39.112 190.528C39.56 191.787 40.488 192.416 41.896 192.416C42.5893 192.416 43.1067 192.283 43.448 192.016C43.8 191.739 43.976 191.381 43.976 190.944C43.976 190.485 43.7893 190.139 43.416 189.904C43.0427 189.659 42.3813 189.392 41.432 189.104C40.8987 188.944 40.4667 188.795 40.136 188.656C39.8053 188.517 39.4533 188.325 39.08 188.08C38.7173 187.824 38.4453 187.509 38.264 187.136C38.0827 186.763 37.992 186.325 37.992 185.824C37.992 184.832 38.344 184.048 39.048 183.472C39.752 182.885 40.6 182.592 41.592 182.592C42.488 182.592 43.272 182.811 43.944 183.248C44.616 183.685 45.1333 184.288 45.496 185.056L43.944 185.952C43.4747 184.907 42.6907 184.384 41.592 184.384C41.0587 184.384 40.632 184.512 40.312 184.768C39.992 185.013 39.832 185.349 39.832 185.776C39.832 186.192 39.992 186.523 40.312 186.768C40.6427 187.003 41.2347 187.253 42.088 187.52C42.5147 187.659 42.824 187.765 43.016 187.84C43.2187 187.904 43.496 188.011 43.848 188.16C44.2107 188.309 44.4827 188.459 44.664 188.608C44.8453 188.757 45.0373 188.944 45.24 189.168C45.4533 189.392 45.6027 189.648 45.688 189.936C45.7733 190.224 45.816 190.549 45.816 190.912C45.816 191.925 45.448 192.731 44.712 193.328C43.9867 193.915 43.032 194.208 41.848 194.208ZM54.275 182.8V184.56H51.123V194H49.283V184.56H46.115V182.8H54.275ZM62.1348 194L61.3508 191.744H56.5828L55.7988 194H53.7988L57.8628 182.8H60.0708L64.1188 194H62.1348ZM57.1908 190.016H60.7428L58.9668 184.96L57.1908 190.016ZM70.1973 194.208C68.5119 194.208 67.1146 193.653 66.0053 192.544C64.8959 191.424 64.3413 190.043 64.3413 188.4C64.3413 186.757 64.8959 185.381 66.0053 184.272C67.1146 183.152 68.5119 182.592 70.1973 182.592C71.2106 182.592 72.1439 182.832 72.9973 183.312C73.8613 183.792 74.5333 184.443 75.0133 185.264L73.4133 186.192C73.1146 185.637 72.6773 185.2 72.1013 184.88C71.5359 184.549 70.9013 184.384 70.1973 184.384C69.0026 184.384 68.0319 184.763 67.2853 185.52C66.5493 186.277 66.1813 187.237 66.1813 188.4C66.1813 189.563 66.5493 190.523 67.2853 191.28C68.0319 192.037 69.0026 192.416 70.1973 192.416C70.9013 192.416 71.5413 192.256 72.1173 191.936C72.6933 191.605 73.1253 191.163 73.4133 190.608L75.0133 191.52C74.5439 192.341 73.8773 192.997 73.0133 193.488C72.1599 193.968 71.2213 194.208 70.1973 194.208ZM84.8843 182.8L80.9803 189.552V194H79.1403V189.552L75.2363 182.8H77.3323L80.0683 187.76L82.7883 182.8H84.8843ZM93.8168 194.208C92.7394 194.208 91.8221 193.963 91.0648 193.472C90.3181 192.981 89.7954 192.309 89.4967 191.456L91.0807 190.528C91.5288 191.787 92.4568 192.416 93.8648 192.416C94.5581 192.416 95.0754 192.283 95.4168 192.016C95.7688 191.739 95.9448 191.381 95.9448 190.944C95.9448 190.485 95.7581 190.139 95.3848 189.904C95.0114 189.659 94.3501 189.392 93.4008 189.104C92.8674 188.944 92.4354 188.795 92.1048 188.656C91.7741 188.517 91.4221 188.325 91.0488 188.08C90.6861 187.824 90.4141 187.509 90.2328 187.136C90.0514 186.763 89.9608 186.325 89.9608 185.824C89.9608 184.832 90.3128 184.048 91.0168 183.472C91.7208 182.885 92.5688 182.592 93.5608 182.592C94.4568 182.592 95.2408 182.811 95.9128 183.248C96.5848 183.685 97.1021 184.288 97.4648 185.056L95.9128 185.952C95.4434 184.907 94.6594 184.384 93.5608 184.384C93.0274 184.384 92.6008 184.512 92.2808 184.768C91.9608 185.013 91.8008 185.349 91.8008 185.776C91.8008 186.192 91.9608 186.523 92.2808 186.768C92.6114 187.003 93.2034 187.253 94.0568 187.52C94.4834 187.659 94.7928 187.765 94.9848 187.84C95.1874 187.904 95.4648 188.011 95.8168 188.16C96.1794 188.309 96.4514 188.459 96.6328 188.608C96.8141 188.757 97.0061 188.944 97.2088 189.168C97.4221 189.392 97.5714 189.648 97.6568 189.936C97.7421 190.224 97.7847 190.549 97.7847 190.912C97.7847 191.925 97.4168 192.731 96.6808 193.328C95.9554 193.915 95.0008 194.208 93.8168 194.208ZM110.012 182.8V194H108.172V186.016L104.764 191.648H104.54L101.132 186V194H99.2919V182.8H101.276L104.652 188.4L108.044 182.8H110.012ZM112.245 182.8H114.085V194H112.245V182.8ZM123.603 182.8V184.56H120.451V194H118.611V184.56H115.443V182.8H123.603ZM131.604 182.8H133.444V194H131.604V189.152H126.804V194H124.964V182.8H126.804V187.392H131.604V182.8Z"
              fill="white"
            />
            <path
              d="M273.881 174V166.727H278.27V167.509H274.761V169.966H278.043V170.747H274.761V173.219H278.327V174H273.881ZM280.283 166.727L282.158 169.753H282.215L284.09 166.727H285.127L282.84 170.364L285.127 174H284.09L282.215 171.031H282.158L280.283 174H279.246L281.59 170.364L279.246 166.727H280.283ZM286.273 174V166.727H288.731C289.301 166.727 289.768 166.83 290.13 167.036C290.494 167.24 290.764 167.516 290.939 167.864C291.115 168.212 291.202 168.6 291.202 169.028C291.202 169.457 291.115 169.846 290.939 170.197C290.767 170.547 290.499 170.826 290.137 171.035C289.775 171.241 289.311 171.344 288.745 171.344H286.983V170.562H288.716C289.107 170.562 289.421 170.495 289.657 170.36C289.894 170.225 290.066 170.043 290.172 169.813C290.281 169.581 290.336 169.32 290.336 169.028C290.336 168.737 290.281 168.477 290.172 168.247C290.066 168.018 289.893 167.838 289.654 167.707C289.415 167.575 289.098 167.509 288.702 167.509H287.154V174H286.273ZM293.502 166.727V174H292.621V166.727H293.502ZM295.267 174V166.727H297.725C298.293 166.727 298.759 166.824 299.124 167.018C299.489 167.21 299.758 167.474 299.934 167.81C300.109 168.147 300.196 168.529 300.196 168.957C300.196 169.386 300.109 169.766 299.934 170.097C299.758 170.429 299.49 170.689 299.127 170.879C298.765 171.066 298.302 171.159 297.739 171.159H295.75V170.364H297.711C298.099 170.364 298.411 170.307 298.648 170.193C298.887 170.08 299.06 169.919 299.167 169.71C299.275 169.5 299.33 169.249 299.33 168.957C299.33 168.666 299.275 168.412 299.167 168.194C299.058 167.976 298.884 167.808 298.645 167.69C298.405 167.569 298.089 167.509 297.696 167.509H296.148V174H295.267ZM298.691 170.733L300.48 174H299.458L297.696 170.733H298.691ZM300.795 166.727H301.803L303.82 170.122H303.906L305.923 166.727H306.931L304.303 171.003V174H303.423V171.003L300.795 166.727Z"
              fill="white"
            />
            <path
              d="M276.78 189.168C275.732 189.168 274.908 188.772 274.308 187.98C273.716 187.18 273.42 186.12 273.42 184.8C273.42 183.48 273.716 182.424 274.308 181.632C274.908 180.832 275.732 180.432 276.78 180.432C277.836 180.432 278.66 180.832 279.252 181.632C279.844 182.424 280.14 183.48 280.14 184.8C280.14 186.12 279.844 187.18 279.252 187.98C278.66 188.772 277.836 189.168 276.78 189.168ZM275.508 186.852C275.796 187.316 276.22 187.548 276.78 187.548C277.34 187.548 277.764 187.312 278.052 186.84C278.348 186.368 278.496 185.688 278.496 184.8C278.496 183.904 278.348 183.22 278.052 182.748C277.764 182.276 277.34 182.04 276.78 182.04C276.22 182.04 275.796 182.276 275.508 182.748C275.22 183.22 275.076 183.904 275.076 184.8C275.076 185.696 275.22 186.38 275.508 186.852ZM284.455 184.008C285.023 184.176 285.483 184.472 285.835 184.896C286.195 185.312 286.375 185.816 286.375 186.408C286.375 187.272 286.083 187.948 285.499 188.436C284.923 188.924 284.215 189.168 283.375 189.168C282.719 189.168 282.131 189.02 281.611 188.724C281.099 188.42 280.727 187.976 280.495 187.392L281.911 186.576C282.119 187.224 282.607 187.548 283.375 187.548C283.799 187.548 284.127 187.448 284.359 187.248C284.599 187.04 284.719 186.76 284.719 186.408C284.719 186.064 284.599 185.788 284.359 185.58C284.127 185.372 283.799 185.268 283.375 185.268H283.015L282.379 184.308L284.035 182.148H280.747V180.6H286.027V181.968L284.455 184.008ZM287.838 190.2H287.154L291.954 179.4H292.638L287.838 190.2ZM293.363 189V187.764L296.231 184.812C296.871 184.14 297.191 183.58 297.191 183.132C297.191 182.804 297.087 182.54 296.879 182.34C296.679 182.14 296.419 182.04 296.099 182.04C295.467 182.04 294.999 182.368 294.695 183.024L293.303 182.208C293.567 181.632 293.947 181.192 294.443 180.888C294.939 180.584 295.483 180.432 296.075 180.432C296.835 180.432 297.487 180.672 298.031 181.152C298.575 181.624 298.847 182.264 298.847 183.072C298.847 183.944 298.387 184.84 297.467 185.76L295.823 187.404H298.979V189H293.363ZM304.611 184.632C305.387 185.096 305.775 185.772 305.775 186.66C305.775 187.436 305.503 188.048 304.959 188.496C304.423 188.944 303.691 189.168 302.763 189.168C301.827 189.168 301.091 188.944 300.555 188.496C300.019 188.048 299.751 187.436 299.751 186.66C299.751 185.772 300.135 185.096 300.903 184.632C300.319 184.208 300.027 183.628 300.027 182.892C300.027 182.116 300.287 181.512 300.807 181.08C301.335 180.648 301.987 180.432 302.763 180.432C303.539 180.432 304.187 180.648 304.707 181.08C305.227 181.512 305.487 182.116 305.487 182.892C305.487 183.636 305.195 184.216 304.611 184.632ZM303.543 182.256C303.343 182.08 303.083 181.992 302.763 181.992C302.443 181.992 302.183 182.08 301.983 182.256C301.783 182.432 301.683 182.672 301.683 182.976C301.683 183.28 301.783 183.524 301.983 183.708C302.183 183.884 302.443 183.972 302.763 183.972C303.083 183.972 303.343 183.884 303.543 183.708C303.743 183.524 303.843 183.28 303.843 182.976C303.843 182.672 303.743 182.432 303.543 182.256ZM301.767 187.308C302.023 187.508 302.355 187.608 302.763 187.608C303.171 187.608 303.499 187.508 303.747 187.308C304.003 187.1 304.131 186.812 304.131 186.444C304.131 186.084 304.003 185.804 303.747 185.604C303.499 185.396 303.171 185.292 302.763 185.292C302.355 185.292 302.023 185.396 301.767 185.604C301.519 185.804 301.395 186.084 301.395 186.444C301.395 186.812 301.519 187.1 301.767 187.308Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-262421025_24617_paint0_linear_1846_3275"
                x1="20"
                y1="-104.5"
                x2="340"
                y2="240.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868787" />
                <stop offset="0.5" stopColor="#E5E5E5" />
                <stop offset="1" stopColor="#BFC3C3" />
              </linearGradient>
              <linearGradient
                id="svg-262421025_24617_paint1_linear_1846_3275"
                x1="46.6"
                y1="71.2519"
                x2="103.296"
                y2="101.534"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A4A4A4" stopOpacity="0.56" />
                <stop offset="0.229167" stopColor="white" stopOpacity="0.72" />
                <stop
                  offset="0.479167"
                  stopColor="#C5C5C5"
                  stopOpacity="0.484186"
                />
                <stop offset="0.729167" stopColor="white" stopOpacity="0.99" />
                <stop offset="1" stopColor="#C5C5C5" stopOpacity="0.74" />
              </linearGradient>
              <linearGradient
                id="svg-262421025_24617_paint2_linear_1846_3275"
                x1="46.6"
                y1="71.2519"
                x2="103.296"
                y2="101.534"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A4A4A4" stopOpacity="0.56" />
                <stop offset="0.229167" stopColor="white" stopOpacity="0.72" />
                <stop
                  offset="0.479167"
                  stopColor="#C5C5C5"
                  stopOpacity="0.484186"
                />
                <stop offset="0.729167" stopColor="white" stopOpacity="0.99" />
                <stop offset="1" stopColor="#C5C5C5" stopOpacity="0.74" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="40"
            height="43"
            viewBox="0 0 40 43"
            fill="none"
            id="svg-1649909847_1240"
          >
            <path
              d="M36.1859 8.97437C34.2091 8.82968 32.3117 8.69871 30.4161 8.5607C30.0381 8.53488 29.7713 8.51625 29.3027 8.40578C28.9538 8.32739 28.2175 8.1452 28.3809 7.7889C28.5466 7.50869 28.6999 7.33086 29.3618 7.31192C31.071 7.27169 32.7725 7.48603 34.4617 7.68956C35.9533 7.8703 37.0879 8.03088 38.3981 8.26871C39.0099 8.37982 39.1702 8.7398 38.9525 9.2703C38.757 9.74634 38.5648 10.2384 38.2834 10.6687C37.2773 12.226 36.2346 13.7508 35.2023 15.2934C35.0752 15.4859 34.9877 15.6436 34.8038 15.851C34.5785 16.1001 34.4284 16.2939 34.1482 16.1282C33.8802 15.9734 34.0075 15.5546 34.1134 15.3565C34.9623 13.6816 36.771 10.2559 36.8257 10.0517C35.7445 10.3961 34.7367 10.6922 33.7438 11.0452C26.8409 13.5362 20.1743 16.4981 14.2934 21.0067C9.6382 24.5755 5.48591 28.6339 1.96319 33.329C1.75337 33.605 1.51727 33.8663 1.28495 34.1136C0.975009 34.4533 0.753635 34.5751 0.566872 34.4269C0.253973 34.1015 0.405556 33.8175 0.506825 33.5805C0.70232 33.1044 1.00157 32.6637 1.29001 32.2352C5.208 26.5439 10.2336 21.9873 15.8798 18.0725C21.6746 14.0542 28.1275 11.4955 34.8208 9.47672C35.1779 9.38368 36.0392 9.07095 36.1859 8.97437Z"
              fill="black"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg86067174_1236"
          >
            <path
              d="M26.2558 44.7319C27.3695 43.0923 28.4316 41.5146 29.4989 39.942C29.7103 39.6275 29.8598 39.4058 30.1898 39.0552C30.4321 38.7922 30.958 38.2457 31.1849 38.5654C31.3447 38.8489 31.4221 39.0706 31.1076 39.6533C30.2878 41.1537 29.2514 42.52 28.2305 43.8812C27.3282 45.0825 26.6219 45.9848 25.7608 47.0006C25.3586 47.4749 24.9668 47.4337 24.6162 46.9799C24.3017 46.5726 23.9717 46.1601 23.7397 45.7012C22.8941 44.0513 22.0949 42.3859 21.2751 40.7206C21.172 40.5143 21.0792 40.3596 20.9915 40.0967C20.8884 39.777 20.7956 39.5502 21.0792 39.3903C21.3473 39.2356 21.6463 39.5553 21.7649 39.7461C22.791 41.3187 24.8534 44.5979 25.0029 44.7474C25.2452 43.6388 25.4927 42.618 25.6835 41.5816C26.9776 34.3581 27.7459 27.1036 26.7817 19.7563C26.0186 13.9404 24.5801 8.31518 22.2754 2.91686C22.1413 2.59719 22.033 2.26205 21.9351 1.93723C21.7959 1.49897 21.801 1.24632 22.0227 1.15867C22.461 1.0504 22.6311 1.32366 22.7858 1.5299C23.1003 1.93723 23.3323 2.41673 23.5592 2.88077C26.529 9.11952 27.9624 15.7501 28.5296 22.5973C29.1122 29.6249 28.1016 36.4927 26.5033 43.2986C26.4053 43.6543 26.2455 44.5566 26.2558 44.7319Z"
              fill="black"
            />
          </svg>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            id="svg-484590915_1528"
          >
            <mask
              id="svg-484590915_1528_mask0_214_14103"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <path
                d="M15.2411 7.77411C15.2411 11.8651 11.9247 15.1815 7.83366 15.1815C3.74266 15.1815 0.426254 11.8651 0.426254 7.77411C0.426254 3.68311 3.74266 0.366699 7.83366 0.366699C11.9247 0.366699 15.2411 3.68311 15.2411 7.77411Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#svg-484590915_1528_mask0_214_14103)"></g>
            <path
              d="M10.8485 5.03449C10.7968 4.91005 10.6979 4.81117 10.5735 4.75949C10.5122 4.7334 10.4465 4.71955 10.3799 4.71875H5.28734C5.15228 4.71875 5.02275 4.7724 4.92724 4.86791C4.83174 4.96341 4.77808 5.09295 4.77808 5.22801C4.77808 5.36307 4.83174 5.49261 4.92724 5.58811C5.02275 5.68361 5.15228 5.73727 5.28734 5.73727H9.15262L4.92577 9.95903C4.87804 10.0064 4.84015 10.0627 4.8143 10.1248C4.78844 10.1868 4.77513 10.2534 4.77513 10.3206C4.77513 10.3878 4.78844 10.4544 4.8143 10.5165C4.84015 10.5785 4.87804 10.6348 4.92577 10.6822C4.97311 10.7299 5.02944 10.7678 5.09149 10.7936C5.15355 10.8195 5.22012 10.8328 5.28734 10.8328C5.35457 10.8328 5.42113 10.8195 5.48319 10.7936C5.54525 10.7678 5.60158 10.7299 5.64892 10.6822L9.87068 6.45532V10.3206C9.87068 10.4557 9.92433 10.5852 10.0198 10.6807C10.1153 10.7762 10.2449 10.8299 10.3799 10.8299C10.515 10.8299 10.6445 10.7762 10.74 10.6807C10.8355 10.5852 10.8892 10.4557 10.8892 10.3206V5.22801C10.8884 5.16146 10.8745 5.09571 10.8485 5.03449V5.03449Z"
              fill="#FF6E66"
            />
          </svg>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            id="svg-134609349_447"
          >
            <path
              d="M12.2194 5.21967C12.5122 4.92678 12.987 4.92678 13.2799 5.21967C13.5728 5.51256 13.5728 5.98732 13.2799 6.28022L8.10998 11.4501C7.84392 11.7162 7.42225 11.7435 7.12365 11.5146L4.29357 9.34467C3.96489 9.09263 3.90288 8.62259 4.1549 8.29389C4.40694 7.96521 4.87698 7.90319 5.20568 8.15522L7.5133 9.92475L12.2194 5.21967Z"
              fill="black"
            />
          </svg>
          <svg
            width="196"
            height="196"
            viewBox="0 0 196 196"
            fill="none"
            id="svg829552244_2744"
          >
            <path
              d="M97.8955 0C151.962 0 195.791 43.8294 195.791 97.8955C195.791 151.962 151.962 195.791 97.8955 195.791C43.8293 195.791 7.01047e-05 151.962 0 97.8955C0 43.8294 43.8293 9.07232e-05 97.8955 0ZM74.2256 20.4414C73.6144 20.1009 73.2324 20.2321 72.5449 20.4268C51.566 26.407 33.8709 40.5696 23.4395 59.7275C12.874 78.7275 10.2446 101.13 16.1191 122.061C22.0941 143.379 36.4269 161.381 55.8672 171.981C66.0066 177.534 79.9001 181.378 91.5732 180.82C101.346 180.522 110.07 177.38 116.868 170.165C122.7 163.975 125.738 155.306 125.277 146.796C124.308 128.907 112.099 117.666 100.058 106.201C87.3897 94.14 72.0285 83.0712 64.0645 67.2598C62.778 64.7058 61.7885 61.9377 61.085 59.1904C60.8065 58.103 60.2419 54.666 59.9346 53.999L59.7051 54.0215C59.0049 55.0027 58.3648 57.1395 57.9355 58.3037C55.316 65.4067 54.4393 72.8772 55.5225 80.3594C57.6592 95.1261 69.0327 105.589 79.5146 115.13C83.8448 119.071 88.4182 122.904 92.7109 126.896C100.355 134.049 109.29 142.572 108.327 153.978C108.091 157.107 107.013 160.115 105.207 162.682C100.977 168.643 94.8094 169.616 88.0684 169.328C77.2665 168.867 67.3603 164.789 58.7373 158.41C53.908 154.827 49.5487 150.65 45.7637 145.978C33.3815 129.929 28.2164 111.568 30.8193 91.3652C33.3117 71.8932 43.3565 54.178 58.79 42.042C60.2796 40.8763 61.8457 39.8097 63.4766 38.8506C65.4522 33.0548 67.5013 28.6438 71.5615 23.8779C72.0962 23.2504 74.3011 20.9991 74.2256 20.4414ZM139.281 23.251C129.142 17.6987 115.248 13.8542 103.575 14.4121C93.8029 14.7108 85.0781 17.8517 78.2803 25.0664C72.4479 31.2563 69.4101 39.9258 69.8711 48.4365C70.8403 66.3252 83.0491 77.5651 95.0908 89.0303C107.759 101.091 123.12 112.161 131.084 127.973C132.37 130.527 133.36 133.295 134.063 136.042C134.342 137.13 134.907 140.565 135.214 141.232L135.443 141.211C136.144 140.23 136.784 138.093 137.213 136.929C139.832 129.826 140.709 122.355 139.626 114.873C137.489 100.106 126.116 89.6422 115.634 80.1016C111.304 76.1605 106.73 72.3274 102.438 68.335C94.7932 61.1825 85.858 52.6593 86.8213 41.2539C87.0576 38.1245 88.1357 35.1168 89.9414 32.5498C94.1714 26.5885 100.339 25.6157 107.08 25.9033C117.882 26.3641 127.788 30.4425 136.411 36.8213C141.241 40.405 145.6 44.5827 149.385 49.2549C161.767 65.3032 166.932 83.6642 164.329 103.867C161.837 123.339 151.791 141.054 136.357 153.19C134.868 154.356 133.303 155.423 131.672 156.382C129.696 162.177 127.647 166.588 123.587 171.354C123.053 171.981 120.847 174.232 120.923 174.79C121.534 175.131 121.916 174.999 122.604 174.805C143.582 168.824 161.278 154.663 171.709 135.505C182.275 116.505 184.904 94.1016 179.029 73.1709C173.054 51.8526 158.721 33.8511 139.281 23.251Z"
              fill="black"
            />
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-jHmTO framer-rcOGl framer-Tt9kv framer-tx7Wz framer-7KstD framer-bpXEc framer-jh6xs6 enin-s1"
        >
          <div className="ssr-variant hidden-1uidno4">
            <div
              className="framer-5z4k1s-container hidden-jh6xs6 hidden-1v4ftp4 enin-s2"
              data-framer-appear-id="5z4k1s"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh enin-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq enin-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 enin-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 enin-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz enin-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz enin-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi enin-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi enin-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi enin-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi enin-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi enin-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 enin-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm enin-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s14">
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze enin-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
            <div
              className="framer-5z4k1s-container hidden-jh6xs6 hidden-1v4ftp4"
              data-framer-appear-id="5z4k1s"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l enin-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq enin-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 enin-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 enin-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz enin-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi enin-s18"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of enin-s19" />
                          <div className="framer-1w1bul6 enin-s19" />
                          <div className="framer-1ku2ucf enin-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-11fpwzz">
            <div
              className="framer-fg3rwu"
              data-framer-name="Hero Main"
              id="accounts"
            >
              <div
                className="framer-1a3ynkm"
                data-framer-name="Hero"
                id="1a3ynkm"
              >
                <div className="framer-l00096" data-framer-name="Hero Text">
                  <div className="framer-ddztcq" data-framer-name="Text">
                    <div className="framer-1up1z90">
                      <div
                        className="framer-12itheb reveal"
                        data-framer-appear-id="12itheb"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1
                          className="framer-text framer-styles-preset-18sajzf enin-s21"
                          data-styles-preset="nXmNeSqma"
                          dir="auto"
                        >
                          &#2344;&#2350;&#2360;&#2381;&#2340;&#2375; &#128591;
                          Banking
                        </h1>
                      </div>
                      <div
                        className="framer-pifqmh reveal"
                        data-framer-appear-id="pifqmh"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1
                          className="framer-text framer-styles-preset-18sajzf enin-s22"
                          data-styles-preset="nXmNeSqma"
                          dir="auto"
                        >
                          beyond borders
                        </h1>
                      </div>
                    </div>
                    <div
                      className="framer-1oug7sd reveal"
                      data-framer-appear-id="1oug7sd"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s23">
                        Spend crypto like cash. Access local fiat currencies
                        from 120+ countries, plus crypto and stablecoins. Live
                        borderless. One powerful app. Hold, swap, and spend any
                        currency like a local, instantly and securely.
                      </p>
                    </div>
                    <div
                      className="framer-1ufe9h6-container enin-s24"
                      data-framer-appear-id="1ufe9h6"
                    >
                      {/*$*/}
                      <a
                        className="framer-jRk8P framer-8i9ql4 framer-v-8i9ql4 framer-14uj2oq enin-s25"
                        data-border="true"
                        data-framer-name="Variant 1"
                        data-highlight="true"
                        href="https://onelink.to/wch597"
                        target="_blank"
                        rel="noopener"
                      >
                        <div className="framer-1ppg5w8 enin-s26" />
                        <div
                          className="framer-1byauid"
                          data-framer-name="Badge"
                        >
                          <div
                            className="framer-4e3fte enin-s27"
                            data-framer-name="_Badge base"
                          >
                            <div
                              className="framer-qxqwxr enin-s28 reveal"
                              data-framer-name="Text"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s29">
                                Now live
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1jm8bdi"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-onc4ii enin-s30 reveal"
                            data-framer-name="Message"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s31">
                              Create your account &#127881;
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="arrow-right"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1hy9p0n enin-s32"
                            aria-hidden="true"
                          />
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-o9kc8w"
                    data-framer-name="iPhone 16 Pro mockup black titanium bottom"
                  >
                    <div
                      data-framer-background-image-wrapper="true"
                      className="enin-s33"
                    >
                      <img
                        decoding="async"
                        width="786"
                        height="1024"
                        sizes="(min-width: 1440px) 605px, (max-width: 809.98px) 332px, (min-width: 810px) and (max-width: 1439.98px) 507px"
                        srcSet="/framerusercontent.com/images/aQfyQdQYQzdoaeiRF1b9R1w.png 786w"
                        src="/framerusercontent.com/images/aQfyQdQYQzdoaeiRF1b9R1w.png"
                        alt=""
                        className="enin-s34"
                      />
                    </div>
                  </div>
                </div>
                <div className="framer-mjzw82">
                  <div
                    className="framer-ju9xo6 hidden-1uidno4"
                    data-framer-appear-id="ju9xo6"
                    data-framer-name="Float_Tag_Amazon"
                  >
                    <div
                      className="framer-1vc52l5"
                      data-framer-name="Rectangle 474"
                    >
                      <div
                        className="framer-1k32ego"
                        data-framer-name="Currency"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame 1437256546"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1eaqetw enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 40 40" className="enin-s37">
                              <use href="#svg-726352421_1977" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-g4x22b"
                        data-framer-name="Frame 1437256476"
                      >
                        <div className="ssr-variant hidden-1v4ftp4">
                          <div
                            className="framer-1vu1si4 enin-s38 reveal"
                            data-framer-name="98,269 \xA3"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s39">
                              $50 Sent to Amazon
                            </p>
                          </div>
                        </div>
                        <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                          <div
                            className="framer-1vu1si4 enin-s38 reveal"
                            data-framer-name="98,269 \xA3"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s40">
                              $50 Sent to Amazon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1gvp0kd hidden-1uidno4"
                    data-framer-appear-id="1gvp0kd"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-awkzhz" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1peh4xd enin-s41"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 52 56" className="enin-s37">
                            <use href="#svg764373717_1237" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1v4ftp4">
                    <div
                      className="framer-1efeyi1 hidden-1uidno4 enin-s42 reveal"
                      data-framer-name="Shop, Spend,   Swap Smartly!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s43">
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">h</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">,</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">d</span>
                          <span className="enin-s45">,</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s43">
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">w</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">p</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">m</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">y</span>
                          <span className="enin-s45">!</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-1efeyi1 hidden-1uidno4 enin-s42 reveal"
                      data-framer-name="Shop, Spend,   Swap Smartly!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s46">
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">h</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">,</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">d</span>
                          <span className="enin-s45">,</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s46">
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">w</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">p</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">S</span>
                          <span className="enin-s45">m</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">y</span>
                          <span className="enin-s45">!</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-6ejymf"
                    data-framer-appear-id="6ejymf"
                    data-framer-name="Float_Tag_Multipurporpose"
                  >
                    <div
                      className="framer-y1o7qe"
                      data-framer-name="Rectangle 474"
                    >
                      <div
                        className="framer-14ehq7"
                        data-framer-name="Currency"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-13q8x1n enin-s47"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (max-width: 809.98px) 23.55px, (min-width: 810px) and (max-width: 1439.98px) 36.39px"
                                srcSet="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 512w,/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 885w"
                                src="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="ssr-variant">
                          <div
                            className="framer-1kh47is enin-s49"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (max-width: 809.98px) max(23.55px, 41.23px), (min-width: 810px) and (max-width: 1439.98px) 36.39px"
                                srcSet="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 512w,/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 885w"
                                src="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="ssr-variant">
                          <div
                            className="framer-ovxpky enin-s50"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (max-width: 809.98px) 23.55px, (min-width: 810px) and (max-width: 1439.98px) 36.39px"
                                srcSet="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 512w,/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 885w"
                                src="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-i0sm1g"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                        <div
                          className="framer-49irg6 enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s39">
                            Multi-purpose Cards
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-49irg6 enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s51">
                            Multi-purpose Cards
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-49irg6 enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s52">
                            Multi-purpose Cards
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1r1jmkj"
                    data-framer-appear-id="1r1jmkj"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-1y1jb5a" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ha6483 enin-s41"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 52 56" className="enin-s37">
                            <use href="#svg764373717_1237" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1uidno4">
                    <div
                      className="framer-13h3tno enin-s53 reveal"
                      data-framer-name="A card for every need"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s54">
                        <span className="enin-s44">
                          <span className="enin-s45">A</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">d</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">f</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">r</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s54">
                        <span className="enin-s44">
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">v</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">y</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">d</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-13h3tno enin-s55 reveal"
                      data-framer-name="A card for every need"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s56">
                        <span className="enin-s44">
                          <span className="enin-s45">A</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">d</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">f</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">r</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s56">
                        <span className="enin-s44">
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">v</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">y</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">d</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-14fe1vd"
                    data-framer-appear-id="14fe1vd"
                    data-framer-name="Float_Tag_GBP"
                  >
                    <div
                      className="framer-mx5jc1"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-7vuvar"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                        <div
                          className="framer-g0vtci enin-s38 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s57">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-g0vtci enin-s38 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s58">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-g0vtci enin-s38 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s59">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                        <div
                          className="framer-1sdlopd enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s60">
                            $98,269
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-1sdlopd enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s51">
                            $98,269
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-1sdlopd enin-s38 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s39">
                            $98,269
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-8x1lgk" data-framer-name="Currency">
                      <div
                        className="framer-yjbr4g"
                        data-framer-name="Ellipse 133"
                      />
                      <div className="framer-1f8ezo7" data-framer-name="Avtar">
                        <div className="ssr-variant">
                          <div
                            className="framer-54ut4q"
                            data-framer-name="Currency"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="204"
                                height="204"
                                src="/framerusercontent.com/images/XZ3bQjqJx8pMohQFIkYYkUzei0.png"
                                alt=""
                                className="enin-s34"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-9o8zv1"
                      data-framer-name="Group 1437256544"
                    >
                      <div
                        className="framer-31bdth"
                        data-border="true"
                        data-framer-name="Ellipse 14984"
                      >
                        <div className="framer-xkuxq7" data-framer-name="bank">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-10uga9h enin-s35"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 14 14" className="enin-s37">
                                <use href="#svg-738554790_445" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-19blf6j enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 14 7" className="enin-s37">
                              <use href="#svg95803052_220" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-ho0y62"
                      data-framer-appear-id="ho0y62"
                      data-framer-name="Arrow"
                    >
                      <div className="framer-c7hwj3" data-framer-name="Arrow">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Group"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-hj0oeh enin-s61"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 59 61" className="enin-s37">
                              <use href="#svg147118731_1233" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1uidno4">
                    <div
                      className="framer-4kp11s enin-s53 reveal"
                      data-framer-name="Multicarrecy account"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s54">
                        <span className="enin-s44">
                          <span className="enin-s45">M</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">i</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">y</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s54">
                        <span className="enin-s44">
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-4kp11s enin-s53 reveal"
                      data-framer-name="Multicarrecy account"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s62">
                        <span className="enin-s44">
                          <span className="enin-s45">M</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">i</span>
                        </span>{' '}
                        <span className="enin-s44">
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">y</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s62">
                        <span className="enin-s44">
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">c</span>
                          <span className="enin-s45">o</span>
                          <span className="enin-s45">u</span>
                          <span className="enin-s45">n</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-f0kfbv hidden-1uidno4"
                    data-framer-appear-id="f0kfbv"
                    data-framer-name="Float_Tag_BTC"
                  >
                    <div
                      className="framer-ip84ci"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-shh6qe"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-1v4ftp4">
                        <div
                          className="framer-1opz1o1 enin-s38 reveal"
                          data-framer-name="BTC Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s57">
                            BTC Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-1opz1o1 enin-s38 reveal"
                          data-framer-name="BTC Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s63">
                            BTC Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1v4ftp4">
                        <div
                          className="framer-fvz6r2 enin-s38 reveal"
                          data-framer-name="0.908 BTC"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s60">
                            0.908 BTC
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-fvz6r2 enin-s38 reveal"
                          data-framer-name="0.908 BTC"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s64">
                            0.908 BTC
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-b6pua4"
                      data-framer-name="Cryptocurrency icon/Bitcoin"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-13wab85 enin-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 40 52" className="enin-s37">
                            <use href="#svg-701020576_3786" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1lhqkjn"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-13dfxun" data-framer-name="bank" />
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1xqmjrq enin-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 14 7" className="enin-s37">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-11cw2in"
                        data-framer-name="wallet2"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1s8twm0 enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 14 11" className="enin-s37">
                              <use href="#svg-212988539_408" />
                            </svg>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-yljt7z enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 14 14" className="enin-s37">
                              <use href="#svg-1448888000_2617" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-gls9wg"
                    data-framer-appear-id="gls9wg"
                    data-framer-name="Float_Tag_USDT"
                  >
                    <div
                      className="framer-tppa8m"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-u11sx3"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                        <div
                          className="framer-1s48rb8 enin-s38 reveal"
                          data-framer-name="USDT Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s57">
                            USDT Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-1s48rb8 enin-s38 reveal"
                          data-framer-name="USDT Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s65">
                            USDT Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-1s48rb8 enin-s38 reveal"
                          data-framer-name="USDT Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s63">
                            USDT Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                        <div
                          className="framer-22c5mn enin-s38 reveal"
                          data-framer-name="30,010 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s60">
                            30,010 USDT
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-22c5mn enin-s38 reveal"
                          data-framer-name="30,010 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s66">
                            30,010 USDT
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                        <div
                          className="framer-22c5mn enin-s38 reveal"
                          data-framer-name="30,010 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s64">
                            30,010 USDT
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-683afv"
                      data-framer-name="Cryptocurrency icon/Tether"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1wuaaex enin-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 58 52" className="enin-s37">
                            <use href="#svg-417222547_3895" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-15eu0k2"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-l8zxqb" data-framer-name="bank" />
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-9f3jk8 enin-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 14 7" className="enin-s37">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-1pb744c"
                        data-framer-name="wallet2"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1akz6rg enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 14 11" className="enin-s37">
                              <use href="#svg-212988539_408" />
                            </svg>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1n5yyam enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 14 14" className="enin-s37">
                              <use href="#svg-1448888000_2617" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-ehodxd"
                      data-framer-appear-id="ehodxd"
                      data-framer-name="Arrow"
                    >
                      <div className="framer-teicp9" data-framer-name="Arrow">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Group"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-45jkbb enin-s61"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 59 61" className="enin-s37">
                              <use href="#svg147118731_1233" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1uidno4">
                    <div
                      className="framer-iwwz8y enin-s67 reveal"
                      data-framer-name="Crypto   wallets"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s68">
                        <span className="enin-s44">
                          <span className="enin-s45">C</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">y</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">o</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s68">
                        <span className="enin-s44">
                          <span className="enin-s45">w</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-iwwz8y enin-s67 reveal"
                      data-framer-name="Crypto   wallets"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s69">
                        <span className="enin-s44">
                          <span className="enin-s45">C</span>
                          <span className="enin-s45">r</span>
                          <span className="enin-s45">y</span>
                          <span className="enin-s45">p</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">o</span>
                        </span>{' '}
                        <span className="enin-s44" />
                      </p>
                      <p dir="auto" className="framer-text enin-s69">
                        <span className="enin-s44">
                          <span className="enin-s45">w</span>
                          <span className="enin-s45">a</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">l</span>
                          <span className="enin-s45">e</span>
                          <span className="enin-s45">t</span>
                          <span className="enin-s45">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1lnhrm5" data-framer-name="Download Links">
              <div className="framer-15aaub2">
                {/*$*/}
                <a
                  data-framer-component-type="SVG"
                  as="a"
                  data-framer-name="app store badge"
                  href="https://apps.apple.com/app/scallop/id6746711366"
                  target="_blank"
                  rel="noopener"
                  parentsize="0"
                  _constraints="[object Object]"
                  rotation="0"
                  shadows=""
                  className="framer-shvfql framer-1dq9b2j enin-s35"
                  aria-hidden="true"
                >
                  <div className="svgContainer enin-s36">
                    <svg viewBox="0 0 120 40" className="enin-s37">
                      <use href="#svg303028490_9230" />
                    </svg>
                  </div>
                </a>
                {/*/$*/}
                {/*$*/}
                <a
                  data-framer-component-type="SVG"
                  as="a"
                  data-framer-name="Play store badge"
                  href="https://play.google.com/store/apps/details?id=com.app.scallop"
                  target="_blank"
                  rel="noopener"
                  parentsize="0"
                  _constraints="[object Object]"
                  rotation="0"
                  shadows=""
                  className="framer-9e2686 framer-1dq9b2j enin-s70"
                  aria-hidden="true"
                />
                {/*/$*/}
              </div>
            </div>
            <div
              className="framer-1y65sj5"
              data-framer-name="Cards"
              id="cardsnew"
            >
              <div className="framer-b2enbc enin-s24" data-framer-name="Text">
                <div
                  className="framer-1tapu94 reveal"
                  data-framer-name="All thing finance, Investment right here"
                  data-framer-component-type="RichTextContainer"
                >
                  <h1
                    className="framer-text framer-styles-preset-18sajzf"
                    data-styles-preset="nXmNeSqma"
                    dir="auto"
                  >
                    <span className="framer-text enin-s71">Cards for your</span>
                    <br className="framer-text" />
                    <span className="framer-text enin-s71">everyday needs</span>
                  </h1>
                </div>
                <div
                  className="framer-1rmtp8q reveal"
                  data-framer-appear-id="1rmtp8q"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Get the card that matches your vibe.{' '}
                  </p>
                </div>
                <div className="framer-wecvyr-container">
                  {/*$*/}
                  <a
                    className="framer-9PalM framer-6q7a9y framer-v-6q7a9y framer-12rwjxo enin-s73"
                    data-border="true"
                    data-framer-name="Primary / Large"
                    data-highlight="true"
                    href="https://onelink.to/wch597"
                    target="_blank"
                    rel="noopener"
                    tabIndex={0}
                  >
                    <div
                      className="framer-1bw53x4 enin-s74 reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text enin-s75">
                        Get your first card free
                      </p>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
              </div>
              <div className="framer-1x0g2in" data-framer-name="card">
                <div className="ssr-variant">
                  <div className="framer-1egyx5t-container enin-s76">
                    <div
                      className="framer-2zHUJ framer-9dffb framer-v-9dffb enin-s3"
                      data-framer-name="Desktop and Tablet"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="1 silver"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-173gyvi enin-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer enin-s36">
                          <svg viewBox="0 0 340 215" className="enin-s37">
                            <use href="#svg-262421025_24617" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-8ujj3n-container enin-s76">
                    <div
                      className="framer-oH5tc framer-k3s785 framer-v-mdmyd8 enin-s3"
                      data-framer-name="Variant 4"
                    >
                      <div
                        className="framer-1w62ec enin-s77"
                        data-framer-name="2"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="680"
                            height="430"
                            sizes="(min-width: 1440px) calc(546px - 8px), (min-width: 810px) and (max-width: 1439.98px) calc(546px - 8px), (max-width: 809.98px) calc(calc((100vw - 32px) * 0.9) - 8px)"
                            srcSet="/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png 512w,/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png 680w"
                            src="/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png"
                            alt=""
                            className="enin-s78"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-1hxropw-container enin-s76">
                    <div
                      className="framer-KM5CQ framer-1smjt6x framer-v-1sq4qag enin-s3"
                      data-framer-name="Variant 3"
                    >
                      <div
                        className="framer-10nuxn3"
                        data-framer-name="telegram-cloud-document-5-6336751571212178983 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="680"
                            height="425"
                            sizes="(min-width: 1440px) calc(546px - 8px), (min-width: 810px) and (max-width: 1439.98px) calc(546px - 8px), (max-width: 809.98px) calc(calc((100vw - 32px) * 0.9) - 8px)"
                            srcSet="/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png 512w,/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png 680w"
                            src="/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png"
                            alt=""
                            className="enin-s48"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-1v34gc4-container enin-s76">
                    <div
                      className="framer-hOjhU framer-txkpid framer-v-j9mgbf enin-s79"
                      data-framer-name="Variant 5"
                    >
                      <div
                        className="framer-1nd56hb"
                        data-framer-name="Group 1437256583"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="680"
                            height="425"
                            src="/framerusercontent.com/images/Uj6oT8ojoT2lH0jKCi5p2ccRJK4.png"
                            alt=""
                            className="enin-s34"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-nswacf" id="featuresnew">
              <div className="framer-1spts1q enin-s24" data-framer-name="Text">
                <div
                  className="framer-17d3mmt"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-bg5fmw enin-s38 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s80">
                      Cards
                    </p>
                  </div>
                </div>
                <div
                  className="framer-grbiac reveal"
                  data-framer-name="All thing finance, Investment right here"
                  data-framer-component-type="RichTextContainer"
                >
                  <h1
                    className="framer-text framer-styles-preset-18sajzf"
                    data-styles-preset="nXmNeSqma"
                    dir="auto"
                  >
                    <span className="framer-text enin-s71">
                      Spend Like Fiat{' '}
                    </span>
                    <br className="framer-text" />
                    <span className="framer-text enin-s71">
                      Send Like Email
                    </span>
                  </h1>
                </div>
                <div
                  className="framer-10hn3ho reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Get the card that matches your vibe.{' '}
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                <div className="framer-1p9125-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-11n7dea enin-s81"
                    data-framer-name="Virtual_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">
                              Virtual Cards
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s86 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (max-width: 809.98px) 77px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (max-width: 809.98px) 96px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj enin-s89"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 enin-s90"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf enin-s91"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 enin-s92"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k enin-s93"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 enin-s30 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s94">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="208"
                                  height="132"
                                  src="/framerusercontent.com/images/llbpo9vv8BCYjZBV7Bqd9XtghV0.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i enin-s30 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s95">
                            <span className="enin-s44">
                              <span className="enin-s45">O</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                              <span className="enin-s45">-</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">m</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">s</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">c</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">&rsquo;</span>
                              <span className="enin-s45">s</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl enin-s96"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t enin-s97"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 43" className="enin-s37">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                <div className="framer-1p9125-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1th6ber enin-s98"
                    data-framer-name="Virtual_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z enin-s72"
                            data-styles-preset="LdcDCdIqD"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s99 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 enin-s100"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (max-width: 809.98px) 77px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (max-width: 809.98px) 96px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj enin-s89"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 enin-s90"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf enin-s91"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 enin-s92"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k enin-s101"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 enin-s30 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s102">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a enin-s103"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="885"
                                  height="552"
                                  sizes="(min-width: 1440px) 48.3514px, (max-width: 809.98px) max(23.55px, 41.23px), (min-width: 810px) and (max-width: 1439.98px) 36.39px"
                                  srcSet="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 512w,/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 885w"
                                  src="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i enin-s30 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s95">
                            <span className="enin-s44">
                              <span className="enin-s45">O</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                              <span className="enin-s45">-</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">m</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">s</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">c</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">&rsquo;</span>
                              <span className="enin-s45">s</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl enin-s96"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t enin-s97"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 43" className="enin-s37">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                <div className="framer-1p9125-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1pueskr enin-s104"
                    data-framer-name="Virtual_Tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">
                              Virtual Cards
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac enin-s72"
                            data-styles-preset="cN9teShfm"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s86 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (max-width: 809.98px) 77px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (max-width: 809.98px) 96px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj enin-s105"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 enin-s106"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf enin-s107"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 enin-s92"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (max-width: 809.98px) 152px, (min-width: 810px) and (max-width: 1439.98px) 291.42px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k enin-s93"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 enin-s30 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s94">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="208"
                                  height="132"
                                  src="/framerusercontent.com/images/llbpo9vv8BCYjZBV7Bqd9XtghV0.png"
                                  alt=""
                                  className="enin-s48"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i enin-s30 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s95">
                            <span className="enin-s44">
                              <span className="enin-s45">O</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                              <span className="enin-s45">-</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">m</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">s</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">c</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">&rsquo;</span>
                              <span className="enin-s45">s</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">t</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl enin-s96"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t enin-s97"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 43" className="enin-s37">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                <div className="framer-papqji-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-4z5m5w enin-s81"
                    data-framer-name="PhysicalDebit_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">Debit Card</p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            Debit card you&apos;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s86 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with scallop at your favorite brand across 150+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 enin-s109"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s enin-s109"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (max-width: 809.98px) 41.15px, (min-width: 810px) and (max-width: 1439.98px) 80px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw enin-s110"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (max-width: 809.98px) 239px, (min-width: 810px) and (max-width: 1439.98px) 296px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid enin-s111"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa enin-s113 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s95">
                            <span className="enin-s44">
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">y</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g enin-s93"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip enin-s30 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s94">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o enin-s114"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="enin-s34"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym enin-s115"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 enin-s116"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 enin-s109"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l enin-s30 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text enin-s94">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe enin-s103"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 40" className="enin-s37">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi enin-s115"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid enin-s117"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx enin-s118 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s119">
                            <span className="enin-s44">
                              <span className="enin-s45">B</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">g</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">t</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">P</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">1</span>
                              <span className="enin-s45">1</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">P</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">o</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                <div className="framer-papqji-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1v8dclk enin-s98"
                    data-framer-name="PhysicalDebit_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z enin-s72"
                            data-styles-preset="LdcDCdIqD"
                          >
                            Debit card you&apos;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s86 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with scallop at your favorite brand across 120+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 enin-s120"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk enin-s120"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 enin-s109"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy enin-s120"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce enin-s120"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s enin-s109"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (max-width: 809.98px) 41.15px, (min-width: 810px) and (max-width: 1439.98px) 80px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s121"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw enin-s110"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (max-width: 809.98px) 239px, (min-width: 810px) and (max-width: 1439.98px) 296px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid enin-s111"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa enin-s122 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s123">
                            <span className="enin-s44">
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">y</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44" />
                          </p>
                          <p dir="auto" className="framer-text enin-s123">
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g enin-s124"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip enin-s30 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s125">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o enin-s126"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="enin-s34"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym enin-s127"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 enin-s128"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 enin-s109"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l enin-s30 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text enin-s125">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe enin-s103"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 40" className="enin-s37">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi enin-s129"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid enin-s130"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx enin-s118 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s131">
                            <span className="enin-s44">
                              <span className="enin-s45">B</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">g</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">t</span>
                            </span>
                          </p>
                          <p className="framer-text enin-s131">
                            <span className="enin-s44" />{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>
                          </p>
                          <p className="framer-text enin-s131">
                            <span className="enin-s44">
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">1</span>
                              <span className="enin-s45">7</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">o</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                <div className="framer-papqji-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1it3f3l enin-s104"
                    data-framer-name="PhysicalDebit_tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">Debit Card</p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac enin-s72"
                            data-styles-preset="cN9teShfm"
                          >
                            Debit card you&apos;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 enin-s86 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with scallop at your favorite brand across 150+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 enin-s109"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce enin-s108"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="enin-s48"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s enin-s109"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (max-width: 809.98px) 41.15px, (min-width: 810px) and (max-width: 1439.98px) 80px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="enin-s78"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw enin-s110"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (max-width: 809.98px) 239px, (min-width: 810px) and (max-width: 1439.98px) 296px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid enin-s111"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa enin-s113 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s95">
                            <span className="enin-s44">
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">a</span>
                              <span className="enin-s45">y</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">r</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">f</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">d</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g enin-s93"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip enin-s30 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s94">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o enin-s114"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="enin-s34"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym enin-s115"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 enin-s116"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 enin-s109"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l enin-s30 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text enin-s94">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe enin-s103"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 40 40" className="enin-s37">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi enin-s115"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s enin-s35"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg viewBox="0 0 16 16" className="enin-s37">
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid enin-s117"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 enin-s112"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 48 48" className="enin-s37">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx enin-s118 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s119">
                            <span className="enin-s44">
                              <span className="enin-s45">B</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">g</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">t</span>
                            </span>
                          </p>
                          <p className="framer-text enin-s119">
                            <span className="enin-s44" />{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">y</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">u</span>
                              <span className="enin-s45">r</span>
                            </span>
                          </p>
                          <p className="framer-text enin-s119">
                            <span className="enin-s44">
                              <span className="enin-s45">i</span>
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">h</span>
                              <span className="enin-s45">o</span>
                              <span className="enin-s45">n</span>
                              <span className="enin-s45">e</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">1</span>
                              <span className="enin-s45">7</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">p</span>
                              <span className="enin-s45">r</span>
                              <span className="enin-s45">o</span>
                            </span>{' '}
                            <span className="enin-s44">
                              <span className="enin-s45">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                <div className="framer-4ir3qb-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1t9qie5 enin-s81"
                    data-framer-name="Metal_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">Metal Card</p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 enin-s133 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 enin-s133"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 enin-s133 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s134">
                                Travel &amp; Purchase Protection
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq enin-s133 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-1eq0uko-container enin-s135">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh enin-s38"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (max-width: 809.98px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 enin-s136"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="enin-s37"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox enin-s137"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (max-width: 809.98px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 enin-s138"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container enin-s38"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="enin-s139">
                                <div
                                  className="framer-epdmfj enin-s140"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (max-width: 809.98px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1jg6j5s enin-s141 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s142">
                          <span className="enin-s44">
                            <span className="enin-s45">T</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">v</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">l</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">n</span>
                            <span className="enin-s45">d</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">p</span>
                            <span className="enin-s45">u</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">h</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">s</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">p</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">o</span>
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">o</span>
                            <span className="enin-s45">n</span>
                            <span className="enin-s45">.</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-q734dq enin-s143 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s142">
                          <span className="enin-s44">
                            <span className="enin-s45">C</span>
                            <span className="enin-s45">l</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">k</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">h</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">d</span>
                          </span>{' '}
                          <span className="enin-s44" />
                        </p>
                        <p className="framer-text enin-s142">
                          <span className="enin-s44">
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">o</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">s</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44" />
                        </p>
                        <p className="framer-text enin-s142">
                          <span className="enin-s44">
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">h</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">m</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">g</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">c</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-8nq8x4 enin-s144"
                        data-framer-name="Arrow"
                      >
                        <div
                          className="framer-1bjnj33"
                          data-framer-name="Arrow"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Group"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-xd7u9c enin-s97"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 40 43" className="enin-s37">
                                <use href="#svg-1649909847_1240" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-qm8711" data-framer-name="USDT">
                        <div
                          className="framer-cmy3q8 enin-s93"
                          data-framer-name="Rectangle 474"
                        >
                          <div
                            className="framer-kculqn enin-s145"
                            data-framer-name="image 285"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 40px, (min-width: 810px) and (max-width: 1439.98px) 35.07px"
                                srcSet="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 512w,/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 1024w"
                                src="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png"
                                alt=""
                                className="enin-s78"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ocouue"
                          data-framer-name="Frame 1437256476"
                        >
                          <div
                            className="framer-1rd3sib enin-s30 reveal"
                            data-framer-name="10$ onetime purchase"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s94">
                              EXCLUSIVE SUPPORT
                            </p>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                <div className="framer-4ir3qb-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1y85s22 enin-s98"
                    data-framer-name="Metal_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z enin-s72"
                            data-styles-preset="LdcDCdIqD"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 enin-s133 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 enin-s133"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 enin-s133 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Travel &amp; Purchase Protect
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq enin-s133 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-16kcjux-container enin-s135">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh enin-s38"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (max-width: 809.98px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 enin-s136"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="enin-s37"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox enin-s137"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (max-width: 809.98px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 enin-s138"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container enin-s38"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="enin-s139">
                                <div
                                  className="framer-epdmfj enin-s140"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (max-width: 809.98px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                <div className="framer-4ir3qb-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-nu57d0 enin-s104"
                    data-framer-name="Metal_Tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa enin-s82"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt enin-s83 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s84">Metal Card</p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob enin-s85 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac enin-s72"
                            data-styles-preset="cN9teShfm"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 enin-s133 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 enin-s133"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 enin-s133 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Travel &amp; Purchase Protect
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l enin-s132"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq enin-s133 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text enin-s134">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak enin-s87"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 enin-s88"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-16kcjux-container enin-s135">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh enin-s38"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (max-width: 809.98px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 enin-s136"
                                aria-hidden="true"
                              >
                                <div className="svgContainer enin-s36">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="enin-s37"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox enin-s137"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="enin-s33"
                              >
                                <img
                                  decoding="async"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (max-width: 809.98px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="enin-s78"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 enin-s138"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container enin-s38"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="enin-s139">
                                <div
                                  className="framer-epdmfj enin-s140"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (max-width: 809.98px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1jg6j5s enin-s141 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s119">
                          <span className="enin-s44">
                            <span className="enin-s45">T</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">v</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">l</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">&amp;</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">P</span>
                            <span className="enin-s45">u</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">h</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">s</span>
                            <span className="enin-s45">e</span>
                          </span>
                        </p>
                        <p className="framer-text enin-s119">
                          <span className="enin-s44">
                            <span className="enin-s45">p</span>
                            <span className="enin-s45">r</span>
                            <span className="enin-s45">o</span>
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">o</span>
                            <span className="enin-s45">n</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-q734dq enin-s146 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s119">
                          <span className="enin-s44">
                            <span className="enin-s45">C</span>
                            <span className="enin-s45">l</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">c</span>
                            <span className="enin-s45">k</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">o</span>
                          </span>{' '}
                          <span className="enin-s44" />
                        </p>
                        <p className="framer-text enin-s119">
                          <span className="enin-s44">
                            <span className="enin-s45">s</span>
                            <span className="enin-s45">e</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">t</span>
                            <span className="enin-s45">h</span>
                            <span className="enin-s45">e</span>
                          </span>{' '}
                          <span className="enin-s44">
                            <span className="enin-s45">m</span>
                            <span className="enin-s45">a</span>
                            <span className="enin-s45">g</span>
                            <span className="enin-s45">i</span>
                            <span className="enin-s45">c</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-8nq8x4 enin-s144"
                        data-framer-name="Arrow"
                      >
                        <div
                          className="framer-1bjnj33"
                          data-framer-name="Arrow"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Group"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-xd7u9c enin-s97"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 40 43" className="enin-s37">
                                <use href="#svg-1649909847_1240" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-qm8711" data-framer-name="USDT">
                        <div
                          className="framer-cmy3q8 enin-s147"
                          data-framer-name="Rectangle 474"
                        >
                          <div
                            className="framer-kculqn enin-s148"
                            data-framer-name="image 285"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 40px, (min-width: 810px) and (max-width: 1439.98px) 35.07px"
                                srcSet="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 512w,/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 1024w"
                                src="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png"
                                alt=""
                                className="enin-s78"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ocouue"
                          data-framer-name="Frame 1437256476"
                        >
                          <div
                            className="framer-1rd3sib enin-s30 reveal"
                            data-framer-name="10$ onetime purchase"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s149">
                              EXCLUSIVE SUPPORT
                            </p>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-2efqlf" data-framer-name="Security">
              <div className="framer-ildv2c" data-framer-name="Content">
                <div className="framer-hnwp5g" data-framer-name="Text">
                  <div
                    className="framer-ig53ab"
                    data-border="true"
                    data-framer-name="Frame 40889"
                  >
                    <div
                      className="framer-1btv0ld enin-s38 reveal"
                      data-framer-name="Label"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text enin-s80">
                        Multi-currency Wallets
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1uidno4">
                    <div
                      className="framer-scmnum reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw enin-s22"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        Your Vault to safely store Across 40+ Currencies.
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-scmnum reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h1 dir="auto" className="framer-text enin-s150">
                        Your Vault to safely store Across 40+ Currencies.
                      </h1>
                    </div>
                  </div>
                  <div
                    className="framer-dp775 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p
                      className="framer-text framer-styles-preset-1rfjbe1 enin-s22"
                      data-styles-preset="TONoa3iGK"
                      dir="auto"
                    >
                      Multi-currency IBANs. Store fiat + crypto + stablecoins
                      securely.
                    </p>
                  </div>
                  <div
                    className="framer-5vq4ae enin-s110 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s151">
                      Enjoy Scallop services in 120+ countries
                    </p>
                  </div>
                  <div
                    className="framer-x6asqx-container"
                    data-framer-name="Intro Animation "
                    name="Intro Animation "
                  >
                    <div
                      name="Intro Animation "
                      className="framer-JZvPS framer-1mo4elg framer-v-u1t6ny"
                      data-framer-name="Circle"
                      data-highlight="true"
                    >
                      <div
                        className="framer-97vvr2 enin-s152"
                        data-framer-name="Arm 8"
                      >
                        <div
                          className="framer-1h70u9z enin-s153"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="800"
                              height="800"
                              sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                              srcSet="/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg 512w,/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg 800w"
                              src="/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                          <div
                            className="framer-1nzwwtq enin-s154"
                            data-framer-name="Ellipse 14986"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="enin-s33"
                            >
                              <img
                                decoding="async"
                                width="383"
                                height="192"
                                src="/framerusercontent.com/images/9BrBcbl7PWAtlaDOgnVGf26Ljk.png"
                                alt=""
                                className="enin-s78"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-16mxd2 enin-s155"
                        data-framer-name="Arm 7"
                      >
                        <div
                          className="framer-6xyw6n enin-s156"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/bXejzZWljInlxK2DbhoV2vDNY.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-p71hv9 enin-s157"
                        data-framer-name="Arm 6"
                      >
                        <div
                          className="framer-132oasx enin-s158"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/qBBo7GjpnVG8U5nKzIk6hvp1TY.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-egxbhz enin-s159"
                        data-framer-name="Arm 5"
                      >
                        <div
                          className="framer-1ofgj2 enin-s160"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/4hbXafIb2iFXvHjrRbHq3LqMQ.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-4o8wgd enin-s161"
                        data-framer-name="Arm 4"
                      >
                        <div
                          className="framer-1ujjrn5 enin-s162"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/lqPvOT9KmCNiif6v7rDQXevkulM.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-92y2vq enin-s163"
                        data-framer-name="Arm 3"
                      >
                        <div
                          className="framer-1fz81na enin-s164"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="2880"
                              height="1728"
                              sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                              srcSet="/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 512w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 1024w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 2048w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 2880w"
                              src="/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-155slis enin-s165"
                        data-framer-name="Arm 2"
                      >
                        <div
                          className="framer-ezgc5b enin-s166"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="2880"
                              height="1516"
                              sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                              srcSet="/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 512w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 1024w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 2048w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 2880w"
                              src="/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1eriryg enin-s167"
                        data-framer-name="Arm 1"
                      >
                        <div
                          className="framer-1wn1iub enin-s168"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/cnd1lbmXaiRVFtcK6zFfVrmlphI.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1syckvf enin-s169"
                        data-framer-name="Arm 0"
                      >
                        <div
                          className="framer-4esxjo enin-s170"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="200"
                              height="200"
                              src="/framerusercontent.com/images/JZOMIWVU0za0ONdJdxgqz0LBmE.png"
                              alt=""
                              draggable={false}
                              className="enin-s78"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <header className="framer-1tb1hwa" data-framer-name="Container">
              <div className="framer-rkergg" data-framer-name="Text container">
                <div className="framer-aqt46o-container">
                  {/*$*/}
                  <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s173 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s174 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/*/$*/}
                </div>
                <div className="framer-ptpbr9-container">
                  {/*$*/}
                  <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s173 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s174 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/*/$*/}
                </div>
                <div className="framer-1n5pc3q-container">
                  {/*$*/}
                  <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s173 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s174 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/*/$*/}
                </div>
                <div className="framer-1avypkj-container">
                  {/*$*/}
                  <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s173 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd enin-s174 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text enin-s172">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/*/$*/}
                </div>
              </div>
              <div className="framer-axdx1e" data-framer-name="Trigger">
                <div className="framer-1kembpw" data-framer-name="1" id="1" />
                <div className="framer-i72wb6" data-framer-name="2" id="2" />
                <div className="framer-1ahl9po" data-framer-name="3" id="3" />
                <div className="framer-2cgtmu" data-framer-name="4" id="4" />
                <div className="framer-10fuzyn" data-framer-name="5" id="5" />
                <div className="framer-1v0xfj5" data-framer-name="6" id="6" />
                <div className="framer-a30z79" data-framer-name="7" id="7" />
                <div className="framer-28tphe" data-framer-name="8" id="8" />
                <div className="framer-19z1k4j" data-framer-name="9" id="9" />
                <div className="framer-14o1s3y" data-framer-name="10" id="10" />
                <div className="framer-oyi9qp" data-framer-name="11" id="11" />
                <div className="framer-1rknro1" data-framer-name="12" id="12" />
                <div className="framer-1px0eet" data-framer-name="13" id="13" />
                <div className="framer-1vr9h46" data-framer-name="14" id="14" />
                <div className="framer-uol2c" data-framer-name="15" id="15" />
              </div>
            </header>
            <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
              <div className="framer-16bth5k-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-4zg99p enin-s175"
                  data-framer-name="Account_Desktop"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s enin-s176"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh enin-s177 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text enin-s178">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 enin-s179 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw enin-s180"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb enin-s86 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 enin-s181"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q enin-s28 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s75">Get your Account</p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="enin-s33"
                      >
                        <img
                          decoding="async"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (max-width: 809.98px) 758px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="enin-s48"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="enin-s182">
                          <div className="enin-s183">
                            <ul className="enin-s184">
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls enin-s187"
                          >
                            <div className="enin-s188">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
              <div className="framer-16bth5k-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-14p0wiq enin-s175"
                  data-framer-name="Accounts_Phone"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s enin-s176"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh enin-s177 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text enin-s178">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 enin-s179 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text enin-s190">
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb enin-s86 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 enin-s181"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q enin-s28 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s75">Get your Account</p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="enin-s33"
                      >
                        <img
                          decoding="async"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (max-width: 809.98px) 758px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="enin-s48"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="enin-s182">
                          <div className="enin-s183">
                            <ul className="enin-s184">
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls enin-s187"
                          >
                            <div className="enin-s188">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
              <div className="framer-16bth5k-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-z7nbr1 enin-s175"
                  data-framer-name="Account tablet"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s enin-s176"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh enin-s177 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text enin-s178">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 enin-s179 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw enin-s180"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb enin-s86 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 enin-s181"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q enin-s28 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text enin-s75">Get your Account</p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="enin-s33"
                      >
                        <img
                          decoding="async"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (max-width: 809.98px) 758px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="enin-s48"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="enin-s182">
                          <div className="enin-s183">
                            <ul className="enin-s184">
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-jey85k enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1l9c9ts enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (max-width: 809.98px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-14bmszs enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="enin-s33"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (max-width: 809.98px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="enin-s78"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-1rurmn9 enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="enin-s185">
                                <div
                                  className="framer-19oda3l enin-s186"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="enin-s33"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (max-width: 809.98px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="enin-s48"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls enin-s187"
                          >
                            <div className="enin-s188">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="enin-s189"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="framer-1fzqyfi"
              data-framer-name="Account type and plan"
              id="account-plans"
            >
              <section
                className="framer-1y76v51"
                data-framer-name="Features"
                id="use-cases"
              >
                <div className="framer-1jnrq9v" data-framer-name="Container">
                  <header className="framer-18348cm" data-framer-name="Header">
                    <div className="ssr-variant hidden-1uidno4">
                      <div
                        className="framer-9dp1k7 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h2
                          className="framer-text framer-styles-preset-120m1vw"
                          data-styles-preset="Sp_YUSQNX"
                          dir="auto"
                        >
                          Regulated Accounts <br className="framer-text" />
                          for Modern Finance
                        </h2>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                      <div
                        className="framer-9dp1k7 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h2 dir="auto" className="framer-text enin-s191">
                          Regulated Accounts <br className="framer-text" />
                          for Modern Finance
                        </h2>
                      </div>
                    </div>
                    <div
                      className="framer-2jer8i enin-s38 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        Scallop offers secure, compliant, and multi-asset
                        accounts,{' '}
                      </p>
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        tailored for business operations and elite personal use.
                      </p>
                    </div>
                  </header>
                  <div className="framer-i2kga0">
                    <div className="framer-173zmwc" data-framer-name="Frame 7">
                      <div
                        className="framer-1c2zdot"
                        data-framer-name="image 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="1105"
                            height="1104"
                            src="/framerusercontent.com/images/f9kcasPp09X0W75IxfCvQWBQgyc.png"
                            alt=""
                            className="enin-s34"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-we7fdy"
                        data-framer-name="Frame 18"
                      >
                        <div
                          className="framer-1fhls34"
                          data-framer-name="Frame 8"
                        >
                          <div
                            className="framer-1tdd4dj enin-s38 reveal"
                            data-framer-name="Basic Account"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h3
                              className="framer-text framer-styles-preset-nhkkac"
                              data-styles-preset="cN9teShfm"
                              dir="auto"
                            >
                              Basic Account
                            </h3>
                          </div>
                          <div
                            className="framer-12hba5q enin-s38 reveal"
                            data-framer-name="A secure, multi-currency account to get started with regulated crypto and fiat services."
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s192">
                              A secure, multi-currency account to get started
                              with regulated crypto and fiat services:
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-11h9d3"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1f7h0r9"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9kxfg6 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-3gfdnk enin-s193 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s194">
                                Multi-currency fiat accounts
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jfr3v7"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-sd5ujy enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1v0ab4u enin-s193"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s194">
                                Swap crypto &lt;-&gt; fiat seamlessly
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1woagrj"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1bjrz6 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-15hcxy8 enin-s193 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s194">
                                Order your debit/credit card
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-2mw695"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-p62d96 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-u86m65 enin-s193 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s194">
                                Instant KYC onboarding
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-t609gk"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1ujqb28 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1ck72ty enin-s193 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s194">
                                Zero charges
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-treqqn"
                      data-border="true"
                      data-framer-name="Frame 8"
                    >
                      <div className="framer-netkb2" data-framer-name="Button">
                        <div
                          className="framer-lni2kv enin-s38 reveal"
                          data-framer-name="Label"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text enin-s195">
                            Coming soon
                          </p>
                        </div>
                      </div>
                      <div className="framer-z4zurc-container">
                        {/*$*/}
                        <video
                          src="/framerusercontent.com/assets/wjxUdafRPbrk5r4ShQFhKjdc.mp4"
                          loop
                          preload="auto"
                          muted
                          playsInline
                          autoPlay
                          className="enin-s196"
                        />
                        {/*/$*/}
                      </div>
                      <div
                        className="framer-19sasn7"
                        data-framer-name="Frame 19"
                      >
                        <div
                          className="framer-1fx5rxf"
                          data-framer-name="Frame 9"
                        >
                          <div
                            className="framer-js6j28 enin-s38 reveal"
                            data-framer-name="Elite Account"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h3
                              className="framer-text framer-styles-preset-nhkkac enin-s197"
                              data-styles-preset="cN9teShfm"
                              dir="auto"
                            >
                              Elite Account
                            </h3>
                          </div>
                          <div
                            className="framer-yc1l2 enin-s38 reveal"
                            data-framer-name="A premium experience with advanced privacy, card perks, and exclusive upgrade benefits."
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s192">
                              ... --- -- . - .... .. -. --. / . -..- -.-. .. -
                              .. -. --. / .. ... / -.-. --- -- .. -. --., ... -
                              .- -.-- / - ..- -. . -..
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-12wamcp"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-o3rocb"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-16oacsu enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1m369x7 enin-s193 reveal"
                              data-framer-name="Comes with Metal Card"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s192">
                                .-.. .- ..- -. -.-. .... .. -. --. / ... --- ---
                                -.
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zb3cpv"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-lwd793 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1i18xgh enin-s193 reveal"
                              data-framer-name="Low FX rates and priority swaps"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s192">
                                ... - .- -.-- / - ..- -. . -..
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-aci5q6"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-kx7m88 enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-fdg2h1 enin-s193 reveal"
                              data-framer-name="Designed for high-volume, crypto-native users"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s192">
                                -... .. --. / .-. . ...- . .- .-.. / .- .... .
                                .- -..
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1y37s66"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-uzhgqc enin-s35"
                              aria-hidden="true"
                            >
                              <div className="svgContainer enin-s36">
                                <svg viewBox="0 0 18 18" className="enin-s37">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-xr65tp enin-s193 reveal"
                              data-framer-name="Priority roadmap access: travel perks, staking rewards"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text enin-s192">
                                .--. .-. . .--. .- .-. . / ..-. --- .-. / .-..
                                .- ..- -. -.-. ....
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="framer-19evrjv" data-framer-name="Security">
              <div
                data-framer-background-image-wrapper="true"
                className="enin-s33"
              >
                <img
                  decoding="async"
                  width="2720"
                  height="1568"
                  sizes="(min-width: 1440px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 100vw, (max-width: 809.98px) 100vw"
                  srcSet="/framerusercontent.com/images/Tyont8o0Ni4ut5IT1ryJC1YmgIg.png 512w,/framerusercontent.com/images/Tyont8o0Ni4ut5IT1ryJC1YmgIg.png 1024w,/framerusercontent.com/images/Tyont8o0Ni4ut5IT1ryJC1YmgIg.png 2048w,/framerusercontent.com/images/Tyont8o0Ni4ut5IT1ryJC1YmgIg.png 2720w"
                  src="/framerusercontent.com/images/Tyont8o0Ni4ut5IT1ryJC1YmgIg.png"
                  alt=""
                  className="enin-s78"
                />
              </div>
              <div className="framer-d5xm1" data-framer-name="Text">
                <div
                  className="framer-1ipe269"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-ugxlfh enin-s38 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s198">
                      Security
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1uidno4">
                  <div
                    className="framer-1yl09hr reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw enin-s199"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Next-Gen Security for Your Digital Finance
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                  <div
                    className="framer-1yl09hr reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2 dir="auto" className="framer-text enin-s200">
                      Next-Gen Security for Your Digital Finance
                    </h2>
                  </div>
                </div>
                <div
                  className="framer-11yz42w reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 enin-s201"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Trusted by users worldwide, regulated in 120+ countries,
                  </p>
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 enin-s201"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    MiCA-compliant, KYC-ready, regulated in the USA, EU, UK,
                    Canada, UAE, and Sri Lanka.
                  </p>
                </div>
                <div
                  className="framer-wcgbvq"
                  data-framer-name="Frame 1707479881"
                >
                  <div className="framer-1k88gah" data-framer-name="image 284">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="enin-s33"
                    >
                      <img
                        decoding="async"
                        width="400"
                        height="136"
                        src="/framerusercontent.com/images/UhBUwcvFVKjpOs5uz7jQMlZ0M.png"
                        alt=""
                        className="enin-s48"
                      />
                    </div>
                  </div>
                  <div className="framer-x6b7sw" data-framer-name="image 299">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="enin-s33"
                    >
                      <img
                        decoding="async"
                        width="750"
                        height="744"
                        sizes="(min-width: 1440px) 36.23px, (min-width: 810px) and (max-width: 1439.98px) 36.23px, (max-width: 809.98px) 36.23px"
                        srcSet="/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png 512w,/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png 750w"
                        src="/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png"
                        alt=""
                        className="enin-s78"
                      />
                    </div>
                  </div>
                  <div className="framer-fck2j7" data-framer-name="image 287">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="enin-s33"
                    >
                      <img
                        decoding="async"
                        width="1200"
                        height="706"
                        sizes="(min-width: 1440px) 47.75px, (min-width: 810px) and (max-width: 1439.98px) 47.75px, (max-width: 809.98px) 47.75px"
                        srcSet="/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 512w,/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 1024w,/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 1200w"
                        src="/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png"
                        alt=""
                        className="enin-s78"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-1kjw015" data-framer-name="Container">
                <div className="framer-2el9np" data-framer-name="Container">
                  <div
                    className="framer-9ob063 enin-s193 reveal"
                    data-framer-name="Virtual Cards"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h3
                      className="framer-text framer-styles-preset-nhkkac enin-s199"
                      data-styles-preset="cN9teShfm"
                      dir="auto"
                    >
                      Biometric &amp; Hardware <br className="framer-text" />
                      Security
                    </h3>
                  </div>
                  <div
                    className="framer-10r2y2u enin-s193 reveal"
                    data-framer-name="Single-use / multi-use / unlimited virtual cards"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s202">
                      Log in effortlessly with Face ID or fingerprint for
                      instant access and protection. Your crypto stays
                      ultra-secure at all times.
                    </p>
                  </div>
                </div>
                <div
                  className="framer-5ao8wp"
                  data-framer-name="SecurityComponents"
                >
                  <div
                    className="framer-1yt3ux7 enin-s193 reveal"
                    data-framer-name="Virtual Cards"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h3
                      className="framer-text framer-styles-preset-nhkkac enin-s199"
                      data-styles-preset="cN9teShfm"
                      dir="auto"
                    >
                      E Money Network &ndash; powered by Scallop
                    </h3>
                  </div>
                  <div
                    className="framer-15swldo enin-s193 reveal"
                    data-framer-name="Single-use / multi-use / unlimited virtual cards"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s202">
                      Our in-house public permissioned Layer 1 chain brings
                      compliance and security to digital finance. Designed for
                      BankFi, PayFi, and RWAs, it features on-chain KYC and
                      native eEUR minting as part of Scallop&rsquo;s product
                      suite. {/*$*/}
                      <a
                        className="framer-text framer-styles-preset-1xun9x3"
                        data-styles-preset="AVnlSva1W"
                        href="https://emoney.io/"
                        target="_blank"
                        rel="noopener"
                      >
                        Read more
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-1a7rckw" />
            </div>
            <div className="framer-1lik254" data-framer-name="FAQ" id="faqs">
              <div className="framer-ptpxkz" data-framer-name="Text">
                <div
                  className="framer-8hi5r6"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-i8tf63 enin-s38 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text enin-s203">
                      QnA
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1uidno4">
                  <div
                    className="framer-u2g5on reveal"
                    data-framer-name="Title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Frequently Asked Questions
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                  <div
                    className="framer-u2g5on reveal"
                    data-framer-name="Title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2 dir="auto" className="framer-text enin-s191">
                      FrequentLY
                      <br className="framer-text" />
                      Asked Questions
                    </h2>
                  </div>
                </div>
                <div
                  className="framer-9h1olc reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Never stay in doubt. Ask any questions you might have.
                  </p>
                </div>
              </div>
              <div className="ssr-variant">
                <div className="framer-clq3lp-container">
                  <div
                    className="framer-YkoZz framer-6lrbie framer-v-6lrbie enin-s3"
                    data-framer-name="FAQs"
                  >
                    <div className="framer-3tjcxc-container">
                      <div
                        className="framer-3HYEH framer-2bq5i1 framer-v-5oim9t enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-13rhdmz"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-cx3vwk enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              How long does it take to open an account?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-bi4uf5"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-1fxario-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-1dyrfwr enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-1wefibd enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s209">
                              Most Scallop accounts can be opened in just a few
                              minutes using our fast, AI-powered verification.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-129fdeq-container">
                      <div
                        className="framer-6n5jq framer-1yqm54p framer-v-rvxee2 enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-w8fkjg"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-tf7hdx enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              Is there a virtual card option?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-1nb39y9"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-1bc2grd-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-zu6ub8 enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-f967u1 enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              Definitely. Scallop offers virtual cards for
                              online shopping, single-use purchases, and
                              subscription management.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-8l17ia-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              Can I send money internationally?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              Absolutely. Scallop lets you send money worldwide,
                              either via local networks or the SWIFT system,
                              depending on your needs.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1isx56l-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              Can I have accounts in different currencies?
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              Yes! Your KYC-approved account gives you access to
                              a wide range of currencies, all under one profile,
                              making it easy to manage global finances.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-2mppbq-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              Does the Scallop card work with Apple Pay and
                              Google Pay?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              Yes! Both virtual and physical cards can be added
                              to Apple Pay and Google Pay for tap-and-go
                              convenience.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1ibrmso-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              What currencies can I exchange with Scallop?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              A Scallop account lets you instantly swap between
                              popular fiat currencies, stablecoins, and digital
                              assets. Learn more in our FAQ section.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1llnln2-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp enin-s204"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j enin-s205 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text enin-s206">
                              Is my money protected in Scallop accounts?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container enin-s38">
                            {/*$*/}
                            <div className="enin-s185" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf enin-s207"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf enin-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text enin-s210">
                              Absolutely. Funds are safeguarded under strict
                              e-money regulations and kept separate from
                              Scallop&rsquo;s company funds.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-15m9fxv" data-framer-name="Partners">
              <div className="framer-ju586s" data-framer-name="Partners">
                <div
                  className="framer-z2h67z enin-s38 reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text enin-s211">
                    Our trusted partners
                  </p>
                </div>
                <div className="framer-19hc5ac-container">
                  {/*$*/}
                  <section className="enin-s212">
                    <ul className="enin-s213">
                      <li>
                        <div
                          className="framer-1ezc608 enin-s214"
                          data-framer-name="image 268"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="684"
                              height="160"
                              sizes="(min-width: 1440px) 171px, (min-width: 810px) and (max-width: 1439.98px) 171px, (max-width: 809.98px) 171px"
                              srcSet="/framerusercontent.com/images/QxvEKQwuSLi4RlGFbXqOvmGVdE.png 512w,/framerusercontent.com/images/QxvEKQwuSLi4RlGFbXqOvmGVdE.png 684w"
                              src="/framerusercontent.com/images/QxvEKQwuSLi4RlGFbXqOvmGVdE.png"
                              alt=""
                              className="enin-s48"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-ikeg9l enin-s214"
                          data-framer-name="image 269"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="632"
                              height="160"
                              sizes="(min-width: 1440px) 158px, (min-width: 810px) and (max-width: 1439.98px) 158px, (max-width: 809.98px) 158px"
                              srcSet="/framerusercontent.com/images/oU0z9e8d1gFXfRDSoUj4pLjDufA.png 512w,/framerusercontent.com/images/oU0z9e8d1gFXfRDSoUj4pLjDufA.png 632w"
                              src="/framerusercontent.com/images/oU0z9e8d1gFXfRDSoUj4pLjDufA.png"
                              alt=""
                              className="enin-s48"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-119nw95 enin-s214"
                          data-framer-name="image 270"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="492"
                              height="160"
                              src="/framerusercontent.com/images/ivSPK23J9RR1a4Hco5h0JeDko.png"
                              alt=""
                              className="enin-s48"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1muzrk9 enin-s214"
                          data-framer-name="image 273"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="480"
                              height="160"
                              src="/framerusercontent.com/images/moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                              alt=""
                              className="enin-s48"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-u2utsu enin-s214"
                          data-framer-name="image 293"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="548"
                              height="168"
                              sizes="(min-width: 1440px) 137px, (min-width: 810px) and (max-width: 1439.98px) 137px, (max-width: 809.98px) 137px"
                              srcSet="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 512w,/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 548w"
                              src="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png"
                              alt=""
                              className="enin-s48"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </section>
                  {/*/$*/}
                </div>
              </div>
            </div>
            <div className="framer-1ehhc93" data-framer-name="CTA">
              <div
                className="framer-1xibneg"
                data-border="true"
                data-framer-name="Frame 1437256478"
              >
                <div className="framer-9ne14t" data-framer-name="CTA">
                  <div className="framer-zyx0l9" data-framer-name="Text">
                    <div className="framer-1tcy7pm">
                      <div className="ssr-variant hidden-1uidno4">
                        <div
                          className="framer-16wsbwk reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2
                            className="framer-text framer-styles-preset-120m1vw"
                            data-styles-preset="Sp_YUSQNX"
                            dir="auto"
                          >
                            GET YOUR SCALLOP ACCOUNT IN MINUTES
                          </h2>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                        <div
                          className="framer-16wsbwk reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2 dir="auto" className="framer-text enin-s191">
                            GET YOUR SCALLOP ACCOUNT IN MINUTES
                          </h2>
                        </div>
                      </div>
                      <div
                        className="framer-np7ocq reveal"
                        data-framer-name="Descriptions"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-1rfjbe1 enin-s72"
                          data-styles-preset="TONoa3iGK"
                          dir="auto"
                        >
                          Join a growing network of partners and customers
                          already thriving with Scallop.
                        </p>
                      </div>
                    </div>
                    <div className="framer-1nyrzj8-container">
                      {/*$*/}
                      <a
                        className="framer-9PalM framer-6q7a9y framer-v-6q7a9y framer-12rwjxo enin-s215"
                        data-border="true"
                        data-framer-name="Primary / Large"
                        data-highlight="true"
                        href="https://onelink.to/wch597"
                        target="_blank"
                        rel="noopener"
                        tabIndex={0}
                      >
                        <div
                          className="framer-1bw53x4 enin-s74 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text enin-s75">
                            Open an Account
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                    <div
                      className="framer-1m2i1jx"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-9yif0r"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="1339"
                            height="495"
                            sizes="(min-width: 1440px) 1002px, (max-width: 809.98px) 409px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px)"
                            srcSet="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 512w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1024w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1339w"
                            src="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png"
                            alt=""
                            className="enin-s34"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                    <div
                      className="framer-1m2i1jx"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-9yif0r"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="1339"
                            height="495"
                            sizes="(min-width: 1440px) 1002px, (max-width: 809.98px) 409px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px)"
                            srcSet="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 512w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1024w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1339w"
                            src="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png"
                            alt=""
                            className="enin-s34"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                    <div
                      className="framer-1m2i1jx"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-9yif0r"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="enin-s33"
                        >
                          <img
                            decoding="async"
                            width="1339"
                            height="495"
                            sizes="(min-width: 1440px) 1002px, (max-width: 809.98px) 409px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px)"
                            srcSet="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 512w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1024w,/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png 1339w"
                            src="/framerusercontent.com/images/tuz5l5DJMBxFmL8Rc3BF8jB0gGo.png"
                            alt=""
                            className="enin-s34"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-7s870a">
              <div className="framer-yzmx0j-container">
                <div className="ssr-variant hidden-1uidno4 hidden-1v4ftp4">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-1rilglu enin-s216"
                    data-framer-name="Desktop"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 699 196" className="enin-s37">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k enin-s217 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s218">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko enin-s35"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 20 20" className="enin-s37">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb enin-s222 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s223">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu enin-s224"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab enin-s225"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 enin-s216"
                    data-framer-name="Mobile"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 699 196" className="enin-s37">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k enin-s217 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s218">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko enin-s35"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 20 20" className="enin-s37">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb enin-s222 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s223">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu enin-s224"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab enin-s225"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-jh6xs6 hidden-1uidno4">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-183e6ee enin-s216"
                    data-framer-name="Tablet"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 enin-s35"
                          aria-hidden="true"
                        >
                          <div className="svgContainer enin-s36">
                            <svg viewBox="0 0 699 196" className="enin-s37">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k enin-s217 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s218">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="enin-s33"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="enin-s78"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks enin-s219 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s220">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                                data-framer-page-link-current="true"
                              >
                                <div
                                  className="framer-wlx7jb enin-s219 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text enin-s221">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko enin-s35"
                            aria-hidden="true"
                          >
                            <div className="svgContainer enin-s36">
                              <svg viewBox="0 0 20 20" className="enin-s37">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb enin-s222 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text enin-s223">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu enin-s224"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab enin-s225"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-1mmsw4a-container">
            {/*$*/}
            {/*/$*/}
          </div>
          <div className="ssr-variant hidden-1uidno4">
            <div
              className="framer-1nwkzx1-container enin-s2"
              data-framer-appear-id="1nwkzx1"
              id="1nwkzx1"
            >
              <div className="ssr-variant hidden-1v4ftp4">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15zawlh enin-s3"
                  data-framer-name="Desktop [Default Boxed]"
                >
                  <header
                    className="framer-ooxjtq enin-s4"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 enin-s5"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 enin-s6"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a className="framer-1jy87r1 framer-145ct8v" href="/">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz enin-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz enin-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpcenter"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 enin-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm enin-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze enin-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text enin-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
              <div className="ssr-variant hidden-jh6xs6">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 enin-s3"
                  data-framer-name="Desktop [Boxed Mini]"
                >
                  <header
                    className="framer-ooxjtq enin-s226"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 enin-s6"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 enin-s5"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a className="framer-1jy87r1 framer-145ct8v" href="/">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz enin-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz enin-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq enin-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpcenter"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi enin-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text enin-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 enin-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm enin-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text enin-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze enin-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text enin-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-jh6xs6 hidden-1v4ftp4">
            <div
              className="framer-1nwkzx1-container"
              data-framer-appear-id="1nwkzx1"
              id="1nwkzx1"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l enin-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq enin-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 enin-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 enin-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz enin-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi enin-s18"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of enin-s19" />
                          <div className="framer-1w1bul6 enin-s19" />
                          <div className="framer-1ku2ucf enin-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default EnIn;
